   export const mossworld = [
    {
      NAME: "Lunularia cruciata",
      DESC: "Widespread as a weed of paths, trampled soil, flower-pots and the damp bases of walls, often found in streets, gardens, churchyards and greenhouses, and sometimes on disused mines. It was used to plug the seams of a Bronze Age canoe discovered in Lincolnshire."
    },
    {
      NAME: "Marchantia polymorpha",
      DESC: "Grows in man-made habitats such as gardens, paths and greenhouses - spread by the production and sale of liners. A pioneer species, frequently the first vegetation to appear after a large wildfire."
    },    {
      NAME: "Blasia pusilla",
      DESC: "A species of moist, non-calcareous soil on damp tracks, forestry tracks and roadsides, in old quarries and clay pits, on waste ground, in ditches and, occasionally, arable fields. Regular associates include Fossombronia wondraczekii, Nardia scalaris, Scapania irrigua, Solenostoma gracillimum, Pogonatum urnigerum and Pohlia annotina."
    },
        {
      NAME: "Conocephalum conicum",
      DESC: "On neutral to basic substrates in a range of damp, shaded habitats, including stream and ditch banks, brick or concrete by streams and rivers, flushes in valley woodland and moist or dripping rocks."
    },    {
      NAME: "Marchantia quadrata",
      DESC: "Found on a wide variety of basic substrates, including soil in calcareous fens and flushes, dune slacks, moist or dry rocks and cliffs, and the crumbling mortar of walls. It grows on basalt, gabbro, limestone, sandstone and schistose rocks, especially where they are lightly shaded in gullies, under overhangs or in earthy crevices, and is a frequent plant in calcareous upland areas. Prominent patches on damp upland rock faces have species such as Anoectangium aestivum, Blindia acuta, Fissidens osmundoides and Gymnostomum aeruginosum as regular associates."
    },    {
      NAME: "Reboulia hemisphaerica",
      DESC: "A rosette- or patch-forming liverwort, usually found in sites which are moist in winter but dry out in summer. These include sandy lanesides and hedgebanks, rocky and earthy banks, rock crevices, limestone pavement, and thin soil on walls. Except in southern England it is a distinct calcicole, growing over limestone, schistose or basic igneous rock. Regular associates include Riccia sorocarpa, Fissidens dubius, Trichostomum brachydontium and several species of Weissia, whilst some colonies grow close to or alongside Targionia hypophylla."
    },    {
      NAME: "Riccia cavernosa",
      DESC: "An annual of seasonally flooded habitats, growing on recently exposed mud at the edge of ponds, lakes, reservoirs and flooded gravel pits, in hollows in arable fields and on damp sand in dune slacks. It occurs on a range of substrates from slightly acid to highly calcareous, often with Aphanorrhegma patens and Bryum klinggraeffii."
    },    {
      NAME: "Riccia fluitans",
      DESC: "An aquatic species, found as scattered plants or in dense masses floating on the surface of water in ponds, clay, gravel and marl pits, ditches, canals and in sheltered swamps at the edge of lakes. It occurs in acidic or basic, mesotrophic to eutrophic water over a range of substrates including clay and peat. It is also found terrestrially on mud or on flat, damp stonework and concrete by the water’s edge. Lemna minor, L. minuta and L. trisulca, vascular plants of the same life-form, are characteristic associates."
    },    {
      NAME: "Riccia sorocarpa",
      DESC: "An ephemeral of sparsely vegetated calcareous or basepoor substrates in sites where the cover of perennial plants is reduced by disturbance or summer drought. It grows in a wide range of such habitats: on thin soil over rocky cliffslopes, limestone hills and basic igneous rocks; on paths and tracks; in quarries and gravel pits; on damp clay or gravelly soil in disturbed woodland rides; on earth-topped walls; in stubble fields, potato fields, Cornish flower fields and as a weed in gardens. It is occasionally found on open base-rich cliff ledges in montane areas. In non-calcareous habitats it is often accompanied by Riccia glauca."
    },    {
      NAME: "Riccia glauca",
      DESC: "An ephemeral of disturbed, acid soil, most characteristically found on base-poor clays and sands in stubble fields and on woodland rides. Arable colonies are usually associated with a diverse range of bryophytes in the Dicranella staphylina–Riccia glauca assemblage (Preston et al., 2010). It is also recorded from a range of other habitats including quarries, gardens, earth-topped walls, riversides, streamsides, lakeside mud, shallow soil on coastal cliff slopes, earthy banks near the sea and (in Cornwall) china-clay workings and flower fields."
    },    {
      NAME: "Metzgeria pubescens",
      DESC: "A strong calcicole of dry, shaded limestone rock, often on vertical surfaces. On Carboniferous Limestone in England and Wales, the main habitat is ravines and north-facing cliffs, where it has a wide range of calcicolous associates. In Scotland, it sometimes grows on siliceous rocks such as sandstone and Old Red Sandstone conglomerate, but always where the substrate is strongly base-rich. The few Irish colonies are on chalk. The lack of records from limestone in Ireland or S Wales suggests that it avoids oceanic areas."
    },    {
      NAME: "Metzgeria fruticulosa",
      DESC: "An epiphyte found mainly on elder and willow, but also on ash, elm and hazel, and less frequently on other trees. It avoids the more acid types of bark. It is often associated with Frullania dilatata, Metzgeria furcata and Cryphaea heteromalla, and sometimes with Cololejeunea minutissima and species of Orthotrichum, Ulota and Zygodon. In SW Britain it may occur in copious quantity on cliff-top elder and blackthorn, and it can also reach great abundance on willow twigs in wet woodland and in the shelter of conifer plantations, for example in the Pennines."
    },    {
      NAME: "Metzgeria furcata",
      DESC: "This species has a wide ecological range, occurring on all but the most acid trees and rocks and being tolerant of drought, although it is seldom found on limestone or decaying wood. On trees it often grows alongside Frullania dilatata, Cryphaea heteromalla, Orthotrichum affine, Ulota phyllantha and Zygodon viridissimus, and is typically a pioneer on the middle part of tree trunks (c. 1.5 to 2.5 m above ground level). It is found on many broadleaved trees, especially ash, sycamore and willow, and there are also records from spruce and other conifers."
    },    {
      NAME: "Riccardia chamedryfolia",
      DESC: "A species of damp or wet habitats, generally behaving as a slight calcicole and avoiding strongly acid conditions. It is widespread in topogenous and soligenous mires, and on dripping rocks and wet ledges, particularly in stream gullies where it can tolerate considerable shade. Silt-free streams sometimes support submerged Riccardia chamedryfolia on rocks or stones, and it has even been recorded on caddis fly cases (Woods, 2002). It is also found on damp soil in a variety of other situations, including banks, tracks, woodland rides, pond and lake margins, fallow fields and dune slacks, often on mineral soils such as clay, although also occurring on sandy and peaty ground. It can grow in habitats liable to dry out at certain times of year as, for example, on chalky banks with Leiocolea turbinata."
    },    {
      NAME: "Pellia endiviifolia",
      DESC: "this plant of strongly basic to slightly acid ground is found on a wide range of wet substrates including sand, soil, outcropping rocks, and, occasionally, peat. It is often a conspicuous part of the ground flora in wet or clayey woodland, and is common in dune slacks, in soil-filled rock crevices, on damp lane banks, and in and by running water. It is frequent at sites of tufa-deposition, where it usually grows in trickling or slow-flowing water in the wetter microhabitats (Pentecost & Zhaohui, 2002, 2006). A good colonising ability is indicated by populations on brick and stone in church gutters, on damp, mortar-rich soil in castle ruins and in active chalk-pits."
    },    {
      NAME: "Pellia epiphylla",
      DESC: "A calcifuge forming extensive sheets on moist or wet soil and acid rock outcrops, particularly on base-poor, somewhat peaty ground, although not usually directly on peat. It grows on the banks of streams, rivers and ditches, but is also common on the ground in woods and in open wetlands. Large patches often occur on lane banks in the north and west, particularly on acid clay and leached loams. Regular associates include Calypogeia arguta, C. fissa, Cephalozia bicuspidata, Dicranella heteromalla, Fissidens bryoides and Hyocomium armoricum."
    },    {
      NAME: "Pellia neesiana",
      DESC: "Soil in non-calcareous marshes and wet flushes is the primary habitat of this species, which is most often found amongst rushes or Molinia with ubiquitous associates such as Lophocolea bidentata, Brachythecium rivulare and Kindbergia praelonga. Colonies may also be mixed with Pohlia wahlenbergii, Pseudephemerum nitidum, Tortula truncata and scrappy patches of Sphagnum. In some areas it also grows on damp clay in woodland rides, along with various rushes and sedges. Its pH preference is for neutral conditions, intermediate between Pellia epiphylla and P. endiviifolia."
    },    {
      NAME: "Aneura pinguis",
      DESC: "Found in a variety of mire communities, generally creeping among other bryophytes. It is most characteristic of circumneutral or base-rich conditions but it also occurs (although usually in small quantity) in base-poor situations such as seepage lines in acid bogs. Associates range from Calliergonella cuspidata, Campylium stellatum and Scorpidium revolvens in fens and calcareous flushes to Sphagnum spp. under more acid conditions. It also occurs in various other damp or wet habitats, including dripping tufa deposits, flushed rocks, lake and stream margins (where it sometimes grows submerged), dune slacks, stony flushes in woodland, and fallen wood in streams. It is a ready colonist of recently exposed base-rich soil, for example in road cuttings, and it may be locally abundant on steep, northfacing slopes in calcicolous grassland."
    },    {
      NAME: "Anthoceros agrestis",
      DESC: "Colonist of bare soils that is almost entirely restricted to arable fields, in contrast to Anthoceros punctatus which sometimes grows in them but is more often found in other habitats. It is a summer annual that grows on neutral or slightly alkaline, water-retentive clay and loam. It is characteristic of the species-rich Tortula truncata– Anthoceros assemblage, which is the most north-western and least abundant of the six British arable bryophyte communities (Preston et al., 2010). Other members of this assemblage include Phaeoceros carolinianus, P. laevis, Fossombronia pusilla, Riccia glauca, Bryum rubens, Dicranella staphylina, Didymodon insulanus, Ephemerum minutissimum, Entosthodon fascicularis, Pleuridium subulatum, T. truncata and Trichodon cylindricus."
    },    
    {
      NAME: "Diplophyllum albicans",
      DESC: "Very common calcifuge occurring in a wide range of habitats such as soil, stumps, logs, boulders and rock faces in woodlands and wooded ravines, banks by footpaths and forestry roads, streamsides, rocky gullies, sphagnum bogs, heaths, and on mountains in virtually all habitats from cliff ledges, block screes, streamsides and moraines to exposed rocky summits and fell fields. Although a calcifuge, it can grow in calcareous areas on thin leached soil, humus or mats of other bryophytes. It is also a common component of montane and oceanic montane bryophyte and hepatic mats. It is favoured by moderate levels of sheep grazing in some habitats, such as high-altitude Pennine blanket bogs."
    },
    {
      NAME: "Scapania compacta",
      DESC: "An aptly named Scapania growing in low dense tufts or extensive sheets in more xeric habitats than most other members of the genus, on exposed dry rock outcrops and boulders, and in rocky gullies, ravines and quarries, especially on rocks with a thin cover of, or pockets of, sandy soil or detritus. It commonly grows by rocky streams, but not as close to the water as S. subalpina. Common on sedimentary, igneous and metamorphic rocks, especially granite, schist and basalt, but rarely on limestone."
    },
    {
      NAME: "Scapania nemorea",
      DESC: "Found in a wide variety of moist or humid habitats, especially lowland broadleaved woods in valleys and ravines, where it inhabits mossy banks, walls, boulders, rock ledges, logs and stumps, growing on moist ground, rock or rotting wood. Common associates are Diplophyllum albicans, Lophocolea bidentata, Lophozia ventricosa, Plagiochila porelloides and Mnium hornum. It is also quite common in more open habitats, including marshes, bogs, open slopes under Calluna, mossy rock faces and rocky gullies. Acid and neutral substrates are the norm, but it can grow in quite obviously basic habitats, including calcareous rocks and base-rich flushes."
    },
    {
      NAME: "Scapania umbrosa",
      DESC: "This, the commonest of the small Scapania species, is not a species you are likely to find unless you are closely scrutinising a moist, rotting log, a damp bank or rock with your hand-lens. Then, its small size (far smaller than S. nemorea, or S. gracilis, with which it sometimes grows), clusters of red gemmae at the shoot tips and sharply pointed, serrate leaf lobes make it stand out. Like many gemmiferous liverworts, heavy rain can wash off many of the gemmae, but you should always be able to find a few if you check a few shoots under a stereomicroscope."
    },
    {
      NAME: "Scapania undulata",
      DESC: "The most widespread and abundant member of the genus in Britain and Ireland, its occupation of a very diverse range of habitats mirrors its phenotypic plasticity and variability. At lower altitudes it is a plant of constantly or intermittently moist places, especially damp sand, gravel, and boulders by streams, both in open situations and in woodlands; also on moist disturbed soil or gravel in old quarries, by woodland tracks and ditches, in seepages on rock faces and on damp rotten logs in wooded ravines. In the uplands more robust phenotypes are common, particularly in flushes, streams and springs."
    },
    {
      NAME: "Scapania gracilis",
      DESC: "Conspicuous hepatic abundant over much of northern and western Britain and Ireland, in a wide range of habitats. It is particularly common in rocky places, especially on acid but sometimes on mildly basic substrates, both in woodland and in more open situations. Habitats include coastal rocky banks and gullies, woods, exposed rocky hillsides, cliffs, block screes and rocky lake margins. In woodland, it often grows in extensive sheets on boulders, logs, stumps and living tree trunks, with associates such as Hymenophyllum wilsonii, Frullania tamarisci, Plagiochila punctata and P. spinulosa. It is usually a conspicuous component of oceanic montane bryophyte mats, both in dwarf-shrub heaths and in sheltered block screes."
    },
    {
      NAME: "Scapania aspera",
      DESC: "A more southern, less montane taxon than Scapania aequiloba, but otherwise quite similar in its ecological requirements. It is abundant in the limestone regions of N England and S Wales; elsewhere it is only locally common on limestones, chalk, basic schists, basic igneous and basic sandstone rocks and soil, and not infrequently on calcareous sand dunes. In chalk or limestone turf it characterises the community Scapanietum asperae (Porley & Rose, 2001)."
    },
    {
      NAME: "Scapania irrigua",
      DESC: "Typically a colonist of damp, disturbed or compacted soil, clay, mud and gravel on footpaths, woodland tracks, old quarries, detritus on streamsides and margins of lakes and reservoirs; also in marshes and boggy pastures. It is occasionally found in coastal dune slacks. Associated bryophytes include Pellia spp., Riccardia chamedryfolia, Calliergonella cuspidata, C. lindbergii, Philonotis fontana and bulbiliferous Pohlia spp. In these habitats it grows generally on acid and circumneutral substrates. A more robust, erect form grows in damp, stony and grassy flushes on mountains, often on base-rich substrates such as limestone and mica-schist."
    },
    {
      NAME: "Pleurozia purpurea",
      DESC: "Scotalnd and Western Ireland. Hess et al. (2005) have demonstrated that Scottish Pleurozia is zoophagous, as it catches small animals in its water sacs in the wild and in laboratory feeding experiments; whether it makes use of the nutrients released by their decomposition and is therefore carnivorous is not yet known."
    },
    {
      NAME: "Marchesinia mackaii",
      DESC: "Locally frequent on dry, shaded or exposed, basic, often highly calcareous rocks and vertical rock walls in lowlying, wooded or treeless gorges or ravines and on shaded rock outcrops, limestone pavements, and cliffs, especially in deciduous woodland with Cololejeunea calcarea, C. rossettiana, Lejeunea cavifolia, Metzgeria furcata and Thamnobryum alopecurum. Strong colonies form extensive black patches that contrast strikingly with pale limestone."
    },
    {
      NAME: "Myriocoleopsis minutissima",
      DESC: "Epiphytic on the trunks, lower branches and upper twigs of willow, poplar, hazel, elder, ash, holly, oak, beech, sycamore, elm, blackthorn, and ivy in wind exposed coastal scrub, in woods near the sea and, to a lesser degree and in reduced abundance, inland. It also grows on gorse and tall Calluna stems, often on steep slopes near the sea, and on conifer trunks in the Isles of Scilly. It occurs more rarely on shaded mildly basic rocks and in ravines near the sea, and on Scillonian dry-stone walls. Common epiphytic associates include Frullania dilatata, Metzgeria furcata, M. violacea and Ulota phyllantha."
    },
    {
      NAME: "Lejeunea cavifolia",
      DESC: "On damp, shaded, basic rock faces, boulders and low cliffs in woods and wooded and treeless ravines, often growing among other bryophytes such as Frullania tamarisci, Metzgeria furcata and Plagiochila porelloides. It also grows on shaded basic montane cliff faces and gullies, on sheltered sea cliffs, on and amongst blocks and in shaded humid recesses in stable block litters, and on shaded soil banks in wooded valleys and by wooded streams."
    },
    {
      NAME: "Radula complanata",
      DESC: "Occurs most commonly as an epiphyte on the trunks, branches and roots of elder, ash, beech, elm, field maple, hawthorn, hazel, sycamore, willow and, more rarely, oak, rowan and numerous other hosts in woods, thickets and hedges. As an epiphyte it avoids deeply shaded sites, and in the drier parts of Britain and Ireland it is most common in wet woods or humid scrub in sheltered localities. Common associates include Frullania dilatata, Metzgeria furcata, Microlejeunea ulicina and Zygodon viridissimus."
    },
    {
      NAME: "Porella platyphylla",
      DESC: "In southern England this species is commonest on and around tree bases and roots, particularly beech and ash, in woodland on chalk soils, and on bare chalk soil on shaded banks, with Anomodon viticulosus, Ctenidium molluscum and Encalypta streptocarpa. It also occurs, more rarely, on logs. Further north and west it is commonest on limestone or other basic rocks and stone walls, usually where there is some light shade. It also occurs on tree bases by streams and in ravines, and in shady lanes and hedges. In its few northern Scottish localities it is mainly on dry but shaded limestone cliffs."
    },
    {
      NAME: "Frullania dilatata",
      DESC: "Most frequent as an epiphyte on the lower branches and trunks of ash, elm, hazel, willow, elder, oak, and, more rarely, rowan, alder, blackthorn, sycamore, beech, and birch in open woods, plantations and hedgerows, growing with Metzgeria furcata, Radula complanata, Homalothecium sericeum, Hypnum cupressiforme and Orthotrichaceae. It also occurs on gorse and heather stems in the west. Sites are usually sheltered and rather dry. It also grows occasionally on rocks in woods and wooded ravines, stone walls, roadside rocks, tombstones, buildings, rocks near the sea, and on fallen logs."
    },
    {
      NAME: "Frullania tamarisci",
      DESC: "Common and locally abundant in several habitats - mossy boulders in deciduous woods; shaded rocks by streams, in ravines, and by the sea; damp turf and grassland both in the lowlands and the uplands, often on basic or calcareous soils; dry, often exposed boulders in stable block litters; stone walls; trunks and lower branches of trees (particularly oak, hazel, ash, birch) and stems of heather and gorse; rotten logs; dwarf-shrub heaths; cliff faces and gullies; shaded peat and earthy banks; and short dune turf. It generally requires some shade or shelter, except in the extreme west of Scotland, and commonly favours mildly basic substrates outside the extreme west. It tends to replace Frullania dilatata as the principal epiphytic Frullania in upland areas."
    },
    {
      NAME: "Fossombronia pusilla",
      DESC: "Pioneer species of disturbed, damp, acid soil in a wide variety of habitats including roadsides and tracksides, ditch, stream and river banks, marshy pastures and stubble fields. It is a characteristic member of the bryophyte flora of periodically disturbed woodland rides, where associates include Riccardia chamedryfolia, Atrichum undulatum, Philonotis fontana and Pohlia species. It shows some preference for loams and clays as opposed to peaty and sandy substrates and as a decided calcifuge is absent from soils derived from chalk and limestone. Arable populations are found almost exclusively in the north-western Tortula truncata–Anthoceros assemblage and Dicranella staphylina– Riccia glauca assemblage (Preston et al., 2010)."
    },
    {
      NAME: "Trichocolea tomentella",
      DESC: "This species is most widely distributed in damp woodlands and shaded ravines, and less frequently in wooded swamps. In favourable conditions it forms extensive patches amongst and over other bryophytes, such as Hookeria lucens, Plagiochila asplenioides and Rhizomnium punctatum in seepage zones, oozes and wet stream banks, and Hyocomium armoricum, Loeskeobryum brevirostre and Saccogyna viticulosa on rock faces by waterfalls and in other humid situations. It also occurs occasionally in more open mesotrophic flushes, mostly on hillsides in the north and west, where associates may include Calliergonella cuspidata, Campylium stellatum and Sphagnum warnstorfii."
    },
    {
      NAME: "Ptilidium ciliare",
      DESC: "Very wide-ranging species in the uplands of Wales, N England and Scotland, extending through submontane heath and grassland, blanket mire, screes and crags, to high montane moss and lichen heath. It is generally less frequent in the lowlands where habitats include dwarf shrub, grass and dune heath, mown heathy grassland in cemeteries, and colliery spoil tips, as well as heathy birch and pine woodland. It usually occurs in scattered patches amongst other bryophytes, on soil, around the base of outcrops or on rock ledges; mostly, but not exclusively, on well-drained base-poor substrates. The scarcity of Irish records of this conspicuous, attractive species is notable. However, it is a species with somewhat continental tendencies, strikingly more abundant in the eastern Highlands of Scotland than in the western."
    },
    {
      NAME: "Lophocolea heterophylla",
      DESC: "On rotting wood, on tree boles and trunks, occasionally on base-poor rocks, sometimes on soil in shade. It is regularly found alongside Lophocolea bidentata, and also grows with Nowellia curvifolia, Dicranum tauricum, Hypnum cupressiforme, Orthodontium lineare and Tetraphis pellucida. In southern and eastern England it is the commonest species of leafy liverwort, but becomes uncommon in the north and west and is usually found on just a handful of logs at northwestern sites."
    },
    {
      NAME: "Lophocolea bidentata",
      DESC: "Common and catholic, especially in damp situations: on soil among grass and mosses, on rotting wood and the roots and boles of trees, and on mossy rocks, walls and boulders. It grows in flushes and fens, by rivers, on rocky hillsides and upland cliffs, and in woods and sand dunes. Lophocolea bidentata is also one of the few liverworts that occurs frequently in mesotrophic grasslands. In eastern England it is often restricted to shaded grassland (e.g. on the north side of churches) and in limestone grassland in Derbyshire its cover decreased in plots which were warmed experimentally in winter by 3°C above ambient to simulate climate warming (Bates et al., 2005)."
    },
    {
      NAME: "Lepidozia reptans",
      DESC: "One of the most widespread and frequent hepatics of deciduous and coniferous woodland in Britain and Ireland. It occurs in patches and scattered amongst mosses on stumps, rotting logs, tree trunks and bases, humus banks and other organic substrates; less commonly it colonises sandstone and other rock types but rarely, if ever, base-rich exposures. It extends outside woodland into heath and moorland, especially in the west and north, where it is also found on block-strewn slopes and other sheltered rocky ground. The decline in records of Lepidozia reptans following reductions in SO2 pollution matches declines observed for other acidophile species."
    },
    {
      NAME: "Blepharostoma trichophyllum",
      DESC: "Seldom present in pure tufts, Blepharostoma trichophyllum is usually found creeping amongst other bryophytes in a variety of communities, on acid and base-rich substrates. It is most frequent on sheltered rock walls and ledges amongst crags and in ravines, with associates such as Amphidium mougeotii, Anoectangium aestivum and Gymnostomum aeruginosum, but it also occurs in flushes, by streams and on peaty moorland banks. In deciduous woodland it grows on tree bases, logs and within cushions of large ground-layer mosses, notably Leucobryum species. The high proportion of pre-1950 records suggests that the species is in long-term decline and this has continued since the mid-1980s in both lowland and upland regions. The reason is unclear."
    },
    {
      NAME: "Kurzia pauciflora",
      DESC: "Primarily a species of saturated peat bogs, where it usually grows amongst sphagnum or on peat in hollows or hummock-sides. It is often associated with other similarly restricted hepatics such as Calypogeia sphagnicola, Cephalozia macrostachya, Cladopodiella fluitans, Mylia anomala and Odontoschisma sphagni. It is recorded from other mire types, including acid flushes and amongst Sphagnum subnitens on tussocks in fens, and also wet heaths and moors."
    },
    {
      NAME: "Bazzania trilobata",
      DESC: "Calcifuge, particularly characteristic of western oak woodland, where in humid conditions it can be locally dominant in the bryophyte layer, forming large, deep cushions on banks, boulders, cliffs and rocky outcrops. Plagiochila spinulosa and Scapania gracilis are common associates. It also grows on deep humus and brown earth soils, especially in grazed woodland, as well as on logs; it is occasionally arboreal. In SE England it is mainly associated with sandstone rocks in shaded valleys. Outside woodland, it occurs in sheltered places on boulder-strewn slopes and block scree, including on some north-facing coasts."
    },
    {
      NAME: "Calypogeia arguta",
      DESC: "Locally abundant on earth banks in woodland and by lanes, as well as creek and stream banks, coastal valleys and, less often, in upland gullies. Cephalozia bicuspidata, Dicranella heteromalla, D. rufescens, Fissidens bryoides, F. celticus and Pseudotaxiphyllum elegans often share the habitat of Calypogeia arguta, but it regularly forms pure patches, especially in deep shade as in the entrance of rabbit holes or badger setts. Siliceous rocks sometimes support colonies, often mixed with Diplophyllum albicans. It is also occasional on Molinia tussocks in marshy grassland, especially in the west."
    },
    {
      NAME: "Calypogeia fissa",
      DESC: "The most widespread and catholic species of Calypogeia in Britain and Ireland. Typical habitats include earth banks in neutral to acid woodland and by lanes, stream and creek banks, siliceous rock outcrops and quarries, decorticated logs, Molinia tussocks in mires and grasslands, and Sphagnum hummocks in bogs. Calypogeia arguta, Cephalozia bicuspidata, Diplophyllum albicans, Atrichum undulatum, Dicranella heteromalla, Kindbergia praelonga, Mnium hornum and Pseudotaxiphyllum elegans are typical associates."
    },
    {
      NAME: "Cephalozia connivens",
      DESC: "Widespread at low altitudes in ombrogenous bogs, valley mires, flushes, damp heathland and moorland. It often grows among Sphagnum, sometimes with other Cephalozia species, but is also found on Leucobryum glaucum hummocks, the sides of Molinia tussocks and on moist peaty soil. In saturated peatlands it commonly occurs with other bog hepatics, including Kurzia pauciflora and Mylia anomala. Less frequently, it is found on old stumps and decaying logs in woodland, or on humus under dense Rhododendron shade, and very occasionally on shaded rock faces."
    },
    {
      NAME: "Nowellia curvifolia",
      DESC: "A species occurring widely on rotting timber, most commonly in deciduous woodland but also quite regularly in conifer plantations. Stumps and the decorticated trunks and branches of a range of broadleaved trees and conifers are colonised. It often forms extensive, strikingly red patches, sometimes in a mixture with other hepatics, including various Cephalozia spp., Lophocolea heterophylla and Odontoschisma denudatum. It also occurs on peaty soil, frequently in moorland, heathland and dry peat bogs, chiefly in the high rainfall areas of the north and west. Very rarely, it is rupestral. There is good evidence that Nowellia increased significantly in the 20th century, and it continues to expand in the south of England and Wales, where it was virtually unknown before 1950."
    },
    {
      NAME: "Cephalozia bicuspidata",
      DESC: "The ecological range of this very common calcifuge overlaps with that of the other Cephalozia species in Britain and Ireland. Equally tolerant of moist mineral and organic soils, as well as growing on rotting logs and damp rock exposures, it occurs in woodlands and in many open habitats, ascending into the montane zone. It also grows in sphagnum bogs and on tussocks in fens, and persists in partially drained mires. In addition, it is invasive in disused quarries, road cuttings, ditch sides and other highly modified sites. There has been a significant and sustained decline in C. bicuspidata from the 1960s onwards."
    },
    {
      NAME: "Cephaloziella hampeana",
      DESC: "Widespread in a range of acid habitats, growing on peaty heathland and moorland banks and among sphagnum in bogs, indeed it is much the most typical wetland Cephaloziella in Britain. It is also found on clay in woodland rides; on sand and gravel in quarries, by tracks and on dunes; on mine waste; on soil among rocks, especially on sea cliffs; and on rock faces in sheltered places such as block screes and treeless ravines. It is absent from some of the drier sites that C. divaricata favours."
    },
    {
      NAME: "Barbilophozia attenuata",
      DESC: "A lowland and subalpine species characteristic of damp shady woodlands where it grows on logs, stumps, tree trunks, peaty soil, base-poor boulders and stone walls, often forming extensive pure stands. In the uplands it also grows in block screes, on sandstone crags and in ravines. Typical associates are Lepidozia reptans, Lophocolea spp., Scapania gracilis, Dicranum fuscescens, D. scoparium and Mnium hornum."
    },
    {
      NAME: "Tritomaria quinquedentata",
      DESC: "Common in a wide diversity of habitats including lowland and subalpine woods, bogs, mountains and, rarely, sand dunes. In woodland it can grow on mossy banks, limestone boulders, shaded walls, tree trunks, stumps and rocky streamsides. At higher altitudes it occurs in mixed bryophyte mats under Calluna, and on rock outcrops, block screes and cliff ledges. In turf, it grows as scattered stems amongst other large bryophytes such as Diplophyllum albicans, Plagiochila spinulosa, Dicranum scoparium, Hylocomium splendens and Mnium hornum."
    },
    {
      NAME: "Barbilophozia floerkei",
      DESC: "Calcifuge, typical of a variety of well-drained substrates, including open moorland slopes under Calluna, old quarries, dry screes, rocky knolls, rock crevices, drystone walls, sandy heaths and fixed coastal dunes. It is rarer in damp situations, such as wet peat in bogs and areas of late snow-lie. The plants often grow as pure stands, or mixed with other calcifuges such as Dicranum scoparium, Isothecium myosuroides, Pleurozium schreberi and Polytrichum spp. At high altitudes, it is typically found in north- to eastfacing block screes, less often near snow patches."
    },
    {
      NAME: "Lophozia ventricosa",
      DESC: "Very common species wherever acid soil or peaty ground is found, so rare only in the more calcareous lowlands of England and Ireland. In the north and west it is found in a multiplicity of habitats from leached sand dunes, woodlands, mossy walls, logs and stumps, to mine waste, old quarries and open peaty and rocky slopes."
    },
    {
      NAME: "Lophozia incisa",
      DESC: "A pioneer, occurring in small glaucous green patches on sphagnum or moist peaty banks, especially in bogs, peat cuttings and damp moorland. It also grows on decaying logs, stumps and litter in damp, open woodland and at the margins of forestry plantations, and on damp humus on river banks and amongst boulders on lake shores. On sandstone and moist shale, it can grow directly on shaded rock faces. On peat, common associates include Calypogeia spp., Cephalozia spp., Diplophyllum albicans, Lepidozia reptans, Mylia anomala and Dicranum scoparium; on decaying logs additional associates are Scapania umbrosa, Tritomaria exsectiformis and Mnium hornum. There are scattered colonies on upland sandstone crags in S Wales, confirmed microscopically."
    },
    {
      NAME: "Lophozia excisa",
      DESC: "A pioneer species, generally calcifuge, but occasionally found on somewhat basic substrates, or on wall tops and boulders enriched by bird droppings. Typical habitats are heathy fixed sand dunes, rocky banks, roadside quarries, colliery spoil heaps, peaty wall tops, sandy and peaty ground on heaths and moorlands, and stony margins of streams, lakes and reservoirs. In the Pennines and coastal S Wales, it occurs fairly frequently on slightly leached soil on ledges of limestone outcrops. It prefers sun-exposed or partly shaded sites, and is rare in woodland. A range of common calcifuge pioneers are typical associates, for example Diplophyllum albicans, Lophozia ventricosa, Nardia scalaris, Scapania scandica, Solenostoma gracillimum, Ceratodon purpureus, Pohlia annotina, P. nutans, Pogonatum urnigerum and Polytrichum juniperinum."
    },
    {
      NAME: "Gymnocolea inflata",
      DESC: "On a wide range of substrates, including peat, rock, sand and clay, always where strongly acid and generally where well illuminated, often where few other plants except Calluna, Campylopus spp. and Pohlia nutans can survive. Its most characteristic habitat is wet heath, where it is sometimes abundant on thin peat at the edge of temporary pools, with Sphagnum species such as S. compactum and S. tenellum as well as the associates mentioned above; but it also grows on eroding blanket peat, rocky banks and intermittently irrigated rocks. Relatively shaded colonies on rock outcrops in open oak woodland tend to be composed of atypically small plants. Very tolerant of pollution, it often occurs near large cities and on toxic waste from copper mining and other extractive industries."
    },
    {
      NAME: "Leiocolea turbinata",
      DESC: "Strict calcicole, growing as thin green patches on moist basic sea banks and cliffs and, rather rarely, in moist dune slacks. Inland it is common on limestones, chalk and Carboniferous sandstones, often in seepages or on shaded humid rocks and boulders in woodland. On these rock types it is also common on rocky river banks, in ravines, on walls (usually on damp mortar), in limestone quarries and chalk pits (on both rock and soil) and on soil in limestone and chalk grassland and scrub. It grows with a range of other calcicolous bryophytes such as Aneura pinguis, Jungermannia atrovirens, Pellia endiviifolia, Didymodon tophaceus, Dicranella varia and Eucladium verticillatum."
    },
    {
      NAME: "Marsupella emarginata",
      DESC: "Frequent and often locally abundant species in a wide range of habitats. It most commonly grows in pure patches on rocks and detritus in and beside streams and lakes; also on soil-covered rocks, rock walls in ravines, old quarries, stone walls, damp banks, gravelly footpaths, spoil heaps, and occasionally on boulders in woodlands. Substrates are typically acid to neutral, rarely calcareous. Common associates are other calcifuges such as Diplophyllum albicans, Polytrichum juniperinum and P. piliferum. On mountains it grows on open stony slopes, rocks by streams, stony flushes, flushed rock slabs and beside snowbeds."
    },
    {
      NAME: "Mylia taylorii",
      DESC: "Forming large cushions in well-drained, sheltered situations, growing on rocks in block scree and woodland, on steep north-facing slopes, and on stumps and the bases of trees in Highland birch woods. It is common under Calluna and other dwarf shrubs in corries and screes, and also on boggy moorlands and scattered among sphagnum. It is a typical component of the mixed montane liverwort communities known as the /‘northern hepatic mat/’. "
    },
    {
      NAME: "Mylia anomala",
      DESC: "Characteristic liverwort of sphagnum bogs, alongside species such as Sphagnum capillifolium, S. magellanicum, S. papillosum, Cephalozia connivens, C. macrostachya and Odontoschisma sphagni. On intact bogs it is most frequent on the sides of hummocks, sometimes extending into hollows where patches of S. papillosum have developed, or on to hummock tops under leggy ericoids. On degraded bogs it may be restricted to Sphagnum-dominated peat cuttings that remain wet when the bog dome has dried out, and it sometimes forms extensive patches on their vertical faces. It has even colonised wet peat spoil in an area of blanket bog at Bellacorick, Co. Mayo, devastated by industrial peat extraction (Farrell & Doyle, 2003)."
    },
    {
      NAME: "Odontoschisma denudatum",
      DESC: "This is one of a number of liverworts found both on rotting logs and peaty soil. In Britain and Ireland it most frequently occurs on the latter, in heathland and moorland, on rocky slopes and boulder scree, commonly on rather shallow organic soils. In the Weald it is found on the moist, peaty faces of vertical sandstone rocks (Paton, 1955). It sometimes grows in bogs, especially in partially drained and cut over sites: on damp but not saturated peat and thus hardly ever overlapping Odontoschisma sphagni. It is often present in small quantity on bogs, but may be abundant, as at Cors Fochno, Cardiganshire. It can also be locally abundant on rotting logs and stumps in deciduous woodland, and occasionally occurs in conifer plantations."
    },
    {
      NAME: "Odontoschisma sphagni",
      DESC: "Characteristic species of ombrogenous mires and valley bogs, and also widespread in moorland and damp heathland. It most frequently grows amongst Sphagnum spp., of which S. papillosum is a particularly common associate, but can form patches on wet peat, the base of Molinia, Eriophorum and Trichophorum tussocks and decaying vegetation. In saturated peatlands Odontoschisma sphagni is sometimes locally prominent amongst other bog hepatics, including Cephalozia spp., Kurzia pauciflora and Mylia anomala. It has also been recorded from Leucobryum glaucum hummocks in rather dry acid grassland (Holyoak, 2012). It is favoured by the periodic burning of wet heath, and decreases in frequency as Calluna vulgaris matures."
    },
    {
      NAME: "Solenostoma gracillimum",
      DESC: "Pioneer species of open or lightly shaded habitats on base-poor substrates, especially on clay, sand and loam. It may thus occur on banks and paths in woods and on moorland, on the banks of streams and ditches, by reservoirs, on cliffs and in old quarries, always in situations which are kept open by trampling, weathering or other disturbance. It may occur as extensive, pure patches on copper-mine spoil, especially where the copper levels are high and the substrate is damp, and on mine spoil with high concentrations of lead and zinc; there is evidence for ecotypic differentiation between populations from sites rich in copper and those on lead-mine spoil (Brown & House, 1978). More rarely it occurs on soft rock such as porous sandstone and decaying shale on the banks of streams and in ravines. Nardia scalaris and Dicranella heteromalla are common associates."
    },
    {
      NAME: "Nardia compressa",
      DESC: "Locally abundant to dominant on rocks in oligotrophic, base-poor, swift-flowing rivers and streams, sometimes on its own and sometimes with associates such as Marsupella emarginata var. aquatica, Atrichum crispum, Hygrohypnum ochraceum and Racomitrium aciculare. It often forms dense turfs, which can be permanently submerged, and it may also colonise dripping cliffs and crags. It is apparently frequent in high-altitude Scottish lochs, and Light & Lewis Smith (1976) found that it even formed 30% cover on rocks at a depth of 20 m on the bed of Loch Coire an Lochain, Braeriach. A marked calcifuge and tolerant of very low pH values, it may persist as a dominant in acidified lakes (Fritz et al., 1989; Rose et al., 2004) and has shown a marked and rapid decline in streams which have been experimentally limed to combat acidification (Wilkinson & Ormerod, 1994)."
    },
    {
      NAME: "Nardia scalaris",
      DESC: "This is a common pioneer on damp, base-poor, sandy and peaty banks, on footpaths, damp roadsides, old quarries, edges of lakes and on the gritty top of rocks in streams. It is especially abundant on fine mineral soils at higher altitudes, growing in scree, in gullies, and on stony summit ridges. Submerged forms can occupy similar habitats to Nardia compressa, occurring as dense turfs on inundated rocks in base-poor streams. There are a number of records from metal mines, although N. scalaris is less often abundant on mines than the superficially similar Solenostoma gracillimum."
    },
    {
      NAME: "Chiloscyphus polyanthos",
      DESC: "Occurs commonly on rocks and boulders in and by streams and rivers, sometimes growing submerged, where it is associated with species such as Scapania undulata and Platyhypnidium riparioides. Stony flushes also regularly support Chyloscyphus polyanthos. Records of C. polyanthos also come from a similar range of habitats to C. pallescens, including marshes, pool and lake margins, stream banks, damp soil in woodland (where it can tolerate considerable shade), rotting wood and wet cliff ledges. Localities vary from mildly basic to moderately acid."
    },
    {
      NAME: "Plagiochila porelloides",
      DESC: "On basic to mildly acid rock faces and rocky banks in woodland, on stone walls, on tree bases, by shaded streams, and on rocks and banks in the uplands. It often grows with Campylopus flexuosus, Dicranum scoparium, Isothecium myosuroides and Plagiothecium succulentum, and sometimes with Plagiochila bifaria, P. punctata or P. spinulosa. In many lowland areas it is largely or entirely restricted to tree bases, especially by streams or rivers. It also occurs on soil banks in woods, albeit less frequently than P. asplenioides, hedgerows and limestone grassland and in sand dunes. Very variable in size and shape, it can form pure tufts or turfs, or grow as scattered shoots through other bryophytes."
    },
    {
      NAME: "Plagiochila bifaria",
      DESC: "Locally frequent in deciduous woodland, where it grows usually in pure tufts or patches on basic to mildly acid rock outcrops, and on the trunks and branches of trees, especially ash and hazel. It is also found on sheltered rock faces in more open situations, especially near the coast in S Wales and SW England, and it is more tolerant of exposure than Plagiochila spinulosa (e.g. Bosanquet, 2010). In the northern part of its range it favours a south-west to south-east aspect. All localities have a mild and humid climate."
    },
    {
      NAME: "Saccogyna viticulosa",
      DESC: "Locally abundant on shaded, slightly moist boulders in deciduous woods (oak, birch, hazel, ash), on damp shaded ledges, banks, and rocks in wooded low-lying ravines and gullies, on and amongst boulders in sheltered block litters, usually north- or east-facing, and on steep, sloping rocks where there is some water seepage and some shade. It also occurs amongst other bryophytes on shaded humus banks by the sea, on rocky coastal slopes, on sheltered sea cliffs, and, more rarely, in damp crevices in granite tors, in hepatic-rich dwarf-shrub heath on steep north- or east-facing block-strewn slopes, and on shaded peaty banks. Indifferent to rock type, often most luxuriant in slightly basic situations but rare on limestone."
    },
   
      {
        NAME: "Rhytidiadelphus squarrosus",
        COUNT: 297,
        COUNTS: 5,
        COMMON: "Springy Turf-moss",
        DESC: "The shoots of this extremely common moss are a few to 10–15 cm long, and distinctive in the way the tapered part of the 2–2.5 mm long leaves bend back at a right angle to the base so that they spread out and away from the stem in all directions, giving shoots a star-like appearance. The broad leaf base completely sheathes the red stem so that it is only visible through the leaves. The leaf has lightly toothed margins and a short, double nerve. Capsules are generally uncommon, but frequent in some areas of south Wales, and may be overlooked elsewhere.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Brachythecium rutabulum",
        COUNT: 210,
        COUNTS: 5,
        COMMON: "Rough-stalked Feathermoss",
        DESC: "B. rutabulum is one of our commonest mosses, though it varies in form and colour, and lacks striking distinguishing characters. It forms loose, medium-sized to fairly robust patches, and its common forms are best known by the irregular, ascending or erect branches, with spreading leaves that are egg-shaped. These do not alter much on drying. Stem and branch leaves are similar in shape, the larger ones reaching 2–3 mm. Though normally egg-shaped, they are sometimes narrower and more or less spearhead-shaped. Often they narrow distinctly to an acute tip, and may taper finely.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Calliergonella cuspidata",
        COUNT: 210,
        COUNTS: 5,
        COMMON: "Pointed Spearmoss",
        DESC: "One of our commonest and most recognizable mosses. It is medium-sized and grows mixed with other bryophytes, or it forms green, yellow-green or occasionally orange-brown patches. Shoots are commonly 3–8 cm long, but sometimes more. The main stem is usually erect and has side branches that are more or less pinnately arranged, the whole shoot having a flattened appearance. The most distinctive field character is the shape of the shoot and branch tips: the leaves are closely rolled-up to form a smooth needle-like or spear-like point.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Hypnum cupressiforme",
        COUNT: 209,
        COUNTS: 5,
        COMMON: "Cypress-leaved Plaitmoss",
        DESC: "This widespread and abundant moss has irregularly branched, slender to medium-sized shoots typically about 2 cm long, and strongly curved leaves, 1–2 mm long, that taper to a long, fine point. The nerve is absent, or very short and double. The shoots are green or tinged with a warm, brownish colour in the older parts. Capsules are frequent, and 2.5 mm long. The lid is beaked.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Campylopus introflexus",
        COUNT: 188,
        COUNTS: 5,
        COMMON: "Heath Star Moss",
        DESC: "This is an easily recognized, often abundant species. It forms dark green or almost black patches that look hoary when dry. Stems may grow to 5 cm long, but are usually much shorter. The leaves are 2.5–6.5 mm long, erect and straight when moist, and more appressed with the hair point often reflexed when dry. Leaves are relatively wide at the base or just above, with the nerve width variable from 30 to 70% of the leaf width and excurrent in a toothed, colourless hair point.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "Hair-like",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Kindbergia praelonga",
        COUNT: 187,
        COUNTS: 5,
        COMMON: "Common Feathermoss",
        DESC: "K. praelonga has regularly branched, pinnate shoots, typically 1–3 cm long, which are more or less triangular. Robust woodland forms have bi-to tripinnate branching patterns and are larger. The most important character is the very marked difference in shape between the stem and branch leaves. Stem leaves are 1–1.5 mm long, triangularly heart-shaped, with a fine, elongated tip which often turns outwards; they are widest just above the base, but narrow abruptly to clasp and run down the stem a little distance in the form of narrow wings.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Ceratodon purpureus",
        COUNT: 174,
        COUNTS: 4,
        COMMON: "Purple Forkmoss",
        DESC: "This very common and very variable species forms cushions or patches which vary from yellow to mid-green through red to purplish-brown, with shoots to 3 cm. The leaves are typically 1.5–2 mm long, narrowly triangular, the lower ones appressed to the stem, the upper somewhat twisted and wavy when dry, normally held away from the stem or slightly reflexed when moist. The leaf margins are recurved almost from the base to the tip. The nerve is stout and ends in the tip of the acutely pointed leaf, which usually has a few coarse teeth.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "Hair-like",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "R",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Dicranella heteromalla",
        COUNT: 166,
        COUNTS: 4,
        COMMON: "Silky Forklet-moss",
        DESC: "In dense, yellow-green to mid-green cushions or patches up to 3 cm deep, but often smaller. Leaves are more or less curved, 3–3.5 mm long, pointing in one direction when moist, and hardly altered when dry. The leaf base is egg-shaped and tapers to a long, fine, channelled point which is toothed, especially near the tip. The nerve is about 30% of the width of the leaf base, occupies most of the tip and is often excurrent. Capsules are common, horizontal or inclined, elliptical in shape and not swollen at the base. The yellow seta becomes browner with age.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "Hair-like",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Grimmia pulvinata",
        COUNT: 163,
        COUNTS: 4,
        COMMON: "Grey-cushioned Grimmia",
        DESC: "This is the commonest British Grimmia, and forms round, almost furry, grey cushions about 1–2 cm tall. The narrow leaves are 3–4 mm long, nerved to the tip, with recurved margins. An important character is the leaf tip, which is abruptly contracted into a long hair point, which may be almost as long as the leaf blade. Oval capsules usually abound, bending back into the cushion on an arching seta (note, however, that when old and dry, the seta straightens and the capsule is held erect); the lid of the capsule has a long beak.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 1
      },
      {
        NAME: "Mnium hornum",
        COUNT: 151,
        COUNTS: 4,
        COMMON: "Swan’s-neck Thyme-moss",
        DESC: "This dark, dull green moss is the commonest species of the genus and one of Britain’s commonest mosses. The upright stems are 2–4 cm tall. Leaves are typically about 4 mm long, but can be as long as 8 mm towards the tip of the shoot, and have a toothed border of long, narrow cells. The nerve usually ends a little below the tip of the leaf. The leaf base at most shortly runs down onto the stem. The lower part of the stem has small, narrowly triangular leaves (the two leaves on the right in the upper drawing). Capsules (5 mm long) are frequently produced, and the lid narrows abruptly into a very short point. The seta is 2.5–5 cm long.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Tortula muralis",
        COUNT: 149,
        COUNTS: 4,
        COMMON: "Summer Screwmoss",
        DESC: "T. muralis is one of the first (and commonest) mosses that beginners will find. It grows in patches, tufts and neat cushions less than 1 cm tall. A long, smooth, silvery, excurrent nerve projects from the rounded leaf tip, making the moss look hoary grey when dry. The tongue-shaped leaf blade is 2–3.5 mm long, and twists and curls when dry, but the leaves spread away from each other when moist. The margins are recurved almost to the tip. The less common var. aestiva has a very short, excurrent green nerve. Narrowly cylindrical capsules develop from spring to autumn. They are held erect on a 1–2 cm long, purple seta, with a long peristome twisted into a spiral.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 2
      },
      {
        NAME: "Hypnum jutlandicum",
        COUNT: 147,
        COUNTS: 4,
        COMMON: "Heath Plaitmoss",
        DESC: "This species typically has a pale green, washed-out colour, and lacks any hint of brownish pigment. The shoots are 2–3 cm long and often somewhat pinnately branched, but the branching is rarely very regular. The leaves are a little less than 2 mm long, nerveless and finely tapering; they are strongly curved towards the underside of the shoot, but often less strongly so than some similar species of Hypnum. The stem is green. H. jutlandicum very often grows on the ground, providing another distinction from H. andoi and H. cupressiforme.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Bryum argenteum",
        COUNT: 144,
        COUNTS: 4,
        COMMON: "Silver-moss",
        DESC: "This is the most recognizable of all British mosses. B. argenteum forms pale green or almost white, compact tufts or patches which look shiny and silvery grey when dry.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 4
      },
      {
        NAME: "Bryum capillare",
        COUNT: 144,
        COUNTS: 4,
        COMMON: "Capillary Threadmoss",
        DESC: "B. capillare is a very common moss that grows in tufts or patches, with stems mostly 1–3 cm tall. Dry plants usually have corkscrew-like shoots, with leaves spirally twisted around the stem. However, in some populations the dry shoots have leaves that are straight or only slightly twisted. The broad leaves are 2–5 mm long, and widest at or above the halfway point. The margins are narrowly recurved and have a well-defined border of narrow cells. The nerve extends into a fine, pale green hair point, which can be short or quite long. B. capillare is dioicous.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Dicranum scoparium",
        COUNT: 139,
        COUNTS: 4,
        COMMON: "Broom Forkmoss",
        DESC: "A medium-to large-sized plant (up to 10 cm), growing in yellow-green to dark green cushions or large patches. The leaves are 4–7.5 mm long, narrowly spearhead-shaped and taper to a long fine tip composed largely of the strong nerve. They are often somewhat curved, but can also be straight and are hardly altered when dry. The leaf margins are usually strongly toothed near the tip. The back of the nerve has raised lines of cells which are just visible with a hand lens. These are also toothed, making the tip of the leaf appear toothed all round.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Polytrichum commune",
        COUNT: 136,
        COUNTS: 4,
        COMMON: "Common Haircap",
        DESC: "Well-grown, large, hummocks or turfs of this species are unmistakable. They consist of tough, wiry shoots up to 40 cm long (usually about 20 cm). When moist, the 8–12 mm long, narrowly spearhead-shaped leaves spread or strongly curve away from the stem, with a glossy sheathing base, giving a starry appearance viewed from above. When dry, the margins become inrolled, wavy and gently twist around the stems. The margins are sharply toothed and the broad nerve is covered with up to 70 ridges of tissue.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 7
      },
      {
        NAME: "Sphagnum fimbriatum",
        COUNT: 131,
        COUNTS: 4,
        COMMON: "Fringed Bogmoss",
        DESC: "Grows as slender, elongated stems, forming loose carpets or soft hummocks. It is all green, apart from the end of male branches which can be brownish; there is never any trace of red or pink. Capitula are small, with a very conspicuous terminal bud.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Dicranoweisia cirrata",
        COUNT: 129,
        COUNTS: 4,
        COMMON: "Common Pincushion",
        DESC: "A small-to medium-sized plant, usually forming neat, yellow-green to mid-green cushions to 3 cm tall. The leaves are about 2.5 mm long, erect and somewhat wavy when moist, and strongly crisped when dry. They are narrowly spearhead-shaped and gradually taper to a finely acute tip. The leaf margins are narrowly recurved and the nerve extends into the tip. Capsules are common, cylindrical and erect on a yellow seta which is often curved when moist. Elliptical gemmae often occur on the back of the leaves near the base.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 4
      },
      {
        NAME: "Pseudotaxiphyllum elegans",
        COUNT: 129,
        COUNTS: 4,
        COMMON: "Elegant Silkmoss",
        DESC: "This very common moss forms sleek mats on shady, acidic banks. The shoots grow up to 3 cm long, are sparingly branched and rather slender, commonly about 2 mm wide, and are flattened in one plane. The leaves are just over 1 mm long, and gradually taper to a fine point. The nerve is very short and double, or absent.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Dichodontium pellucidum",
        COUNT: 128,
        COUNTS: 4,
        COMMON: "Transparent Forkmoss",
        DESC: "D. pellucidum is variable, but usually grows in lax, mid-green cushions or turfs, 1–7 cm high. Leaves are incurved and somewhat shrunken when dry, spreading and often markedly reflexed when moist. They are typically 1.5–2.5 mm long, 2.5 to 4 times as long as wide, spearhead-or egg-shaped from a relatively broad base, narrowing to an acute or blunt tip which is usually coarsely toothed. The nerve is stout and toothed at the back near the tip and the cells in the upper surface of the leaf have a very rough, uneven surface, which can be seen with a hand lens. Capsules are uncommon, egg-shaped and curved, and about 1–2 times as long as wide.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "O",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Schistidium apocarpum",
        COUNT: 128,
        COUNTS: 4,
        COMMON: "Sessile Grimmia",
        DESC: "This is the second commonest Schistidium in lowland Britain and becomes increasingly frequent in humid parts of the north and west. Its typical form grows in loose cushions or patches of sparsely branched shoots, 0.5–5 cm long, with curved leaves (2.25–3.5 mm long) that have a very short hair point, and rather short capsules. Upland forms often have straighter leaves and longer hair points, thus mimicking various other Schistidium species, so care and microscopical checking are needed.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 2
      },
      {
        NAME: "Cratoneuron filicinum",
        COUNT: 127,
        COUNTS: 4,
        COMMON: "Fern-leaved Hookmoss",
        DESC: "The pinnate shoots of this very variable moss are typically 1–3 cm long, with a rather pale tip. The leaves are rigid, with a stout nerve prominent all the way to the tip, making the shoots look spiky. Leaves are 1 mm long, and straight or slightly or strongly curved; in the latter case the branches may look hooked. Stem leaves are triangular, broadest just above the base, and taper evenly to a fine, acute tip. With a good hand lens, it is possible to see patches of enlarged cells in the leaf base. Branch leaves are narrower: broadly spearhead-shaped to egg-shaped. The stem bears red-brown rhizoids, and may also have tiny leaf-like structures.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Sphagnum fallax",
        COUNT: 121,
        COUNTS: 4,
        COMMON: "Flat-topped Bogmoss",
        DESC: "Medium-sized, green to mustard-brown, growing in carpets. Male plants may have a contrasting darker tip to the capitula and spreading branches. Capitula are convex and usually stellate, with developing branches in neat pairs, obvious between the capitula rays. Branch leaves are weakly to clearly in straight lines. Spreading and pendent branches are well-differentiated; the pendent branches are almost white, appressed to and hiding the stem, about as long as or shorter than the spreading branches. The stem leaf is more or less triangular with a sharply pointed tip that has a minutely pinched apex.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Polytrichum piliferum",
        COUNT: 117,
        COUNTS: 4,
        COMMON: "Bristly Haircap",
        DESC: "A low-growing (usually about 4 cm or less) species that forms open patches. Shoots have a characteristic shape, the short leaves being densely clustered at the shoot tip, leaving the reddish stem somewhat bare below. The greyish-green leaves are about 3 mm long, and the tip is drawn out to a long, white hair point, most noticeable on dry shoots when several tips project above the rigid, appressed leaves as a terminal brush. Each leaf has untoothed, incurved margins that partly hide longitudinal ridges of tissue on the upper surface.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 9,
        MOISTURE: 3
      },
      {
        NAME: "Platyhypnidium riparioides",
        COUNT: 113,
        COUNTS: 4,
        COMMON: "Long-beaked Water Feathermoss",
        DESC: "P. riparioides occurs in or near water and varies considerably depending on the conditions. In clean water, it may form large patches of long, sparingly branched shoots (to 10 cm or more), the older parts of the stems often becoming denuded.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 10
      },
      {
        NAME: "Rhizomnium punctatum",
        COUNT: 113,
        COUNTS: 4,
        COMMON: "Dotted Thyme-moss",
        DESC: "Erect shoots are 1–10 cm tall. The large (5–6 mm long) leaves are broadly elliptical to egg-shaped (but widest above the middle), with a differentiated border of elongated cells that lacks teeth. The nerve ends shortly below the tip. The stems are red or brown. Tufts of large rhizoids arise from the leaf axils and form a dark felt on the lower part of the shoots. The more slender rhizoids seen in R. pseudopunctatum and R. magnifolium are absent. Damp substrates are often covered by a greenish-brown, alga-like felt, from which small, sparse, leafy shoots arise. Capsules are frequent in autumn and winter, about 4–5 mm long, with a beaked lid. Setae are 2–3 cm long.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 8
      },
      {
        NAME: "Barbula convoluta",
        COUNT: 112,
        COUNTS: 4,
        COMMON: "Lesser Bird’s-claw Beardmoss",
        DESC: "B. convoluta forms distinctive, bright yellow-green cushions or tight turfs. The shoots are typically 0.5–2 cm tall (occasionally up to 2.5 cm), and have rather spreading leaves which become very twisted when dry. The leaves are usually less than 1.5 mm long, more or less parallel-sided and have a shortly tapered tip. The nerve ends in the tip or may be very shortly excurrent. The leaf margins may be recurved below, but this can be difficult to see. Capsules are not all that common, but they are often very abundant when they do occur, and held upright on a yellow seta. The leaves immediately next to the base of the seta enfold it (hence the specific name",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Orthotrichum affine",
        COUNT: 109,
        COUNTS: 4,
        COMMON: "Wood Bristlemoss",
        DESC: "This common moss forms loose, slightly branched, dull, mid-green or yellowish-green tufts 0.8–3.5 cm tall. Individual leaves are about 3 mm long, have recurved margins, and end in an acute tip. Its abundant capsules can be found all year round: they ripen in summer, but old capsules persist into the winter. Unripe capsules are covered by a light green, slightly hairy calyptra, which is often tipped pale brown.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "O",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Rhynchostegium confertum",
        COUNT: 105,
        COUNTS: 4,
        COMMON: "Clustered Feathermoss",
        DESC: "This very common moss forms mid-green patches on wood and stones. It is irregularly branched, with prostrate, ascending or curved branches. Branch and stem leaves are similar, 1–1.5 mm long, egg-shaped or narrowly egg-shaped, tapering to a slender point. They are moderately concave and sometimes slightly curved to the side. When dry, they are not or only slightly shrunken, and not at all twisted. The leaves have a single nerve and very finely toothed margins. Capsules are common and often plentiful. These are curved, egg-shaped or oblong, with a beaked lid, and borne on a rather short (6–10 mm long), erect, smooth seta.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Plagiomnium undulatum",
        COUNT: 104,
        COUNTS: 4,
        COMMON: "Hart’s-tongue Thyme-moss",
        DESC: "When well-grown, this is a striking and unmistakable moss with tongue-shaped, undulate leaves 2–5 mm long. Its stems may be tall (up to 15 cm long) and branched, like a tiny tree. The leaf base runs down onto the stem. However, stunted forms are much less distinctive, with shorter and scarcely undulate leaves. In spring, shoots with immature, pointed leaves, can also be confused with other species. Difficult forms can be identified by the leaf cells, which are much smaller than in other Plagiomnium species, and hardly longer than wide.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Plagiothecium undulatum",
        COUNT: 104,
        COUNTS: 4,
        COMMON: "Waved Silkmoss",
        DESC: "A large and conspicuous moss, with pale green, sparsely branched shoots, several centimetres long, commonly 5–6 mm wide, that are more or less flattened in one plane. The leaves are about 3 mm long, and conspicuously wavy when either moist or dry. The nerve is short and double. Capsules are uncommon.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Pogonatum aloides",
        COUNT: 103,
        COUNTS: 4,
        COMMON: "Aloe Haircap",
        DESC: "As its name suggests, P. aloides resembles a small Aloe, with its short, stiff, dark green, rather triangular leaves arranged in a rosette-like tuft on short, stout, reddish stems.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Campylopus flexuosus",
        COUNT: 101,
        COUNTS: 4,
        COMMON: "Bandy-shanks",
        DESC: "A very variable species, usually forming dark green tufts or patches, the stems often matted with red-brown rhizoids, with the shoots varying in height, sometimes up to 8 cm tall, but normally much less. The leaves are 2–7 mm long, straight and erect, but in some forms can be curved and pointing in one direction when moist. When dry, the upper leaves in particular become distinctly wavy. The leaf narrows only very gradually near the base and then tapers to a long tip composed largely of nerve; the nerve can occupy up to 60% of the width of the leaf near the base, but is usually narrower than this. The cells at the basal corners are normally distinct and red-brown.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Racomitrium aciculare",
        COUNT: 101,
        COUNTS: 4,
        COMMON: "Yellow Fringemoss",
        DESC: "A widespread and locally dominant moss in rivers in western Britain. Shoots are 2 to several centimetres long. Although it frequently lives up to its English name, with a yellow-green colour, R. aciculare is often dark green or almost black. The 2.5–",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Orthotrichum diaphanum",
        COUNT: 96,
        COUNTS: 4,
        COMMON: "White-tipped Bristlemoss",
        DESC: "The white leaf tip of O. diaphanum is immediately diagnostic within the genus and makes this very common species look more like a Schistidium than an Orthotrichum.",
        ORDER: "Orthotrichales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "O",
        LIGHT: 7,
        MOISTURE: 3
      },
      {
        NAME: "Sphagnum denticulatum",
        COUNT: 95,
        COUNTS: 4,
        COMMON: "Cow-horn Bogmoss",
        DESC: "A medium to large species. Plants are green, yellow-brown to dull coppery red, sometimes with a purplish tint. The outer capitulum branches are swollen and smooth in outline, the leaves with flat edges, that sheath and clasp those above.",
        ORDER: "Sphagnales",
        HABITAT: "HARD ROCK",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Brachythecium rivulare",
        COUNT: 86,
        COUNTS: 4,
        COMMON: "River Feathermoss",
        DESC: "B. rivulare is often characteristically bright, golden or yellow-green. The stem leaves are about 2.5 mm long, broadly to narrowly egg-shaped, concave, somewhat pleated, with finely toothed margins, and have a single nerve extending above mid-leaf. Their most distinctive feature, however, is the formation of a clearly marked colourless patch of cells in the basal angles of the leaves. These run down onto the stem, and in well-marked forms extend onto the stem as broad wings. They are strongest and most easily observed on the main stems (pull away some of the leaves to reveal the base of the others). Capsules are rare and have a roughened seta.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Atrichum undulatum",
        COUNT: 85,
        COUNTS: 4,
        COMMON: "Catherine’s Moss",
        DESC: "This is one of our most robust and distinctive acrocarpous mosses and soon becomes familiar to beginners. It is a loosely tufted, moderately robust species that can form extensive patches. These tend to be dark green, but are yellower when well-lit. Individual stems are erect, unbranched, and grow to 7 cm, with long, narrow, pointed leaves up to 1 cm long. Each leaf is distinctly transversely undulate when moist, and strongly crisped when dry. The leaf margins have paired teeth from near the base, and the back is rough, with numerous small teeth. The nerve ends in the leaf tip.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Polytrichum juniperinum",
        COUNT: 84,
        COUNTS: 4,
        COMMON: "Juniper Haircap",
        DESC: "A medium-sized Polytrichum, forming extensive, open patches of unbranched, erect shoots about 3 to 4 cm tall, with leaves up to about 1 cm long. The reddish stems are clothed with evenly spaced, greyish-green leaves with untoothed margins and a distinctive, red-brown tip. When dry, the leaf margins are strongly inrolled, and the leaves are slightly flexed and appressed to the stem, the whole shoot becoming sharply pointed and slightly glaucous in appearance. In spring, the male plants are very conspicuous, with their bright, reddish-orange, modified leaves forming small terminal ‘flowers’ at the shoot ends.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 5
      },
      {
        NAME: "Philonotis fontana",
        COUNT: 81,
        COUNTS: 4,
        COMMON: "Fountain Apple-moss",
        DESC: "A variable plant, with pale yellowish-green or glaucous green upright shoots, several centimetres tall, red stems and a mat of red-brown rhizoids covering the lower part of stems. Scrappy, juvenile shoots may be less than 1 cm long and lie flat on the ground; these look very different from well-developed shoots in flushes, and often occur on disturbed ground. The short (0.8–1.5 mm), triangular leaves have corrugated surfaces, with a prominent nerve and recurved margins. On male plants (bottom right photograph), the leaves surrounding the red-brown inflorescences have a rounded tip, with the nerve ceasing below the tip.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Barbula unguiculata",
        COUNT: 79,
        COUNTS: 4,
        COMMON: "Bird’s-claw Beardmoss",
        DESC: "This species grows in distinctive, bright yellow-green turfs up to 1.5 cm tall. The leaves are usually 1.5–2 mm long, and spread away from the stem when moist, but take on a tight spiral twist when dry, making the yellow nerve very conspicuous. Each leaf is parallel-sided for most of its length with a rounded tip from which the nerve protrudes in a short, thick point. The margins are recurved, often for most of the length of the leaf. Capsules are not common, but when present are borne upright on a red seta.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Pohlia nutans",
        COUNT: 78,
        COUNTS: 4,
        COMMON: "Nodding Threadmoss",
        DESC: "Rather variable in appearance, shoots are typically 1–2 cm tall, dull, dark green in the upper part and pale brown below, and form patches or tufts. The upper part of stems is reddish, with brown rhizoids on the lower part of stems. The spearhead-shaped leaves are larger (about 4.5 mm long) and more crowded towards the tops of shoots, and smaller below (about 2.5 mm long). The nerve ceases just below the leaf tip, and the leaves lack a border. Short-leaved branches often protrude above the cushions. Horizontal or pendulous capsules 3 mm long frequently form in spring and summer. Setae vary in length, but may be quite long – up to about 4 cm.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 5
      },
      {
        NAME: "Polytrichastrum formosum",
        COUNT: 73,
        COUNTS: 4,
        COMMON: "Bank Haircap",
        DESC: "A medium-sized plant with erect, unbranched, scattered shoots in loose tufts, 5–10 cm tall, and leaves 1 cm long or slightly more. The bright, dark green, straight leaves hug the stem, becoming wavy and duller when dry. The spreading, narrow, triangular limb extends from a matt, colourless sheathing base. Narrow, colourless margins are distinctly toothed, and become inrolled to protect the up to 70 ridges of tissue on the upper surface of the nerve as the leaf dries out. The (4-) 5-to 6-angled, erect to inclined, rather rectangular capsule with a long (2 mm) lid is borne on a 2.5–6 cm seta, yellowish above, red below.",
        ORDER: "Polytrichales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Didymodon rigidulus",
        COUNT: 72,
        COUNTS: 4,
        COMMON: "Rigid Beardmoss",
        DESC: "This is the commonest Didymodon species on calcareous stone. Its shoots form dark green tufts, 0.5–1 cm tall. The narrow leaves are about 1.5–3 mm long, taper gradually to the tip, and have more prominent nerves than other Didymodon species.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 5,
        MOISTURE: 4
      },
      {
        NAME: "Didymodon insulanus",
        COUNT: 71,
        COUNTS: 4,
        COMMON: "Cylindric Beardmoss",
        DESC: "This very common moss grows in patches or loose tufts on soil. Typical shoots are 0.5–3 cm tall, olive-green, and often brownish on the lower part. The narrow upper leaves average 3–4 mm in length (longer than the lower leaves), with a long, tapering tip. Each one curves to the side, giving shoots a spiralled appearance when viewed from above, and they curl and twist into a characteristic shape (see inset photograph) when dry. Erect, cylindrical capsules are very rare in spring, and are borne on a wavy seta.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Bryum dichotomum",
        COUNT: 70,
        COUNTS: 4,
        COMMON: "Bicoloured Bryum",
        DESC: "B. dichotomum is usually less than 1 cm tall, growing in compact tufts, or scattered shoots, with rather concave leaves which are short (2–2.5 mm) in relation to their width in comparison to many other Bryum species. 1–5 bulbils (about 1 mm long) frequently occur in many of the leaf axils. Pendulous, egg-shaped capsules are often produced in autumn and winter. They are rather rounded and short, varying in length between 1 and 2.5 mm, and pass abruptly into a seta which is only 8–15 mm long.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Aulacomnium palustre",
        COUNT: 69,
        COUNTS: 4,
        COMMON: "Bog Groove-moss",
        DESC: "A. palustre forms tufts 3–12 cm tall, with pale yellow-green leaves that contrast strongly with the ginger-brown, felt-like rhizoids which cover the stem. Shoots occasionally terminate in an elongated stalk with a terminal cluster of gemmae. When dry, the leaves become somewhat crisped and twisted. The leaves are 4–6 mm long near the top of the shoot, but shorter below, spearhead-shaped, shortly pointed, matt and pale yellow-green. Curved, furrowed capsules 2.5 mm long are produced occasionally.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "O",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Bryoerythrophyllum recurvirostrum",
        COUNT: 69,
        COUNTS: 4,
        COMMON: "Red Beardmoss",
        DESC: "This moss forms quite large, loose, soft sheets or turfs up to 5 cm tall. It is quite distinctive, with narrow, spreading, straight or recurved, bright green upper leaves often contrasting markedly with the rusty red lower leaves and stem; because of the loose growth form, this can usually be seen with the plants in situ. The leaves are about 3–4 mm long, narrow, tapering from a somewhat expanded base to an acute tip, which may have a few teeth. There is usually a distinct change in taper just below the tip. The leaf margins are obviously recurved for most of their length and the nerve ends in the tip. Cylindrical capsules are quite common and are held erect on a red seta.",
        ORDER: "Pottiales",
        HABITAT: "GRAVEL SAND",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 5
      },
      {
        NAME: "Racomitrium lanuginosum",
        COUNT: 66,
        COUNTS: 4,
        COMMON: "Woolly Fringemoss",
        DESC: "Locally abundant in upland Britain, this is one of the few bryophytes familiar to many non-bryologists. It is a large (shoots 2 to several centimetres long), irregularly branched, upright, grey-green plant with a conspicuous hair point at the end of 3–6 mm long leaves that often curve in one direction. Through a hand lens, the toothed edges of the hair point provide a unique character to confirm the identification of atypical or half-dead plants.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Sciuro-hypnum populeum",
        COUNT: 66,
        COUNTS: 4,
        COMMON: "Matted Feathermoss",
        DESC: "B. populeum has fairly slender, prostrate shoots which are closely attached to the substrate, with short, erect, crowded side branches. Branch leaves are about 1 mm long, spearhead-shaped and narrow to a long, fine point. Stem leaves are similar, but a little broader. The leaves are crowded and appressed when dry, giving the shoots a silky appearance. A very important character is the strong nerve, extending almost to the tip of the leaf, and this can usually be confirmed with a hand lens. Curved and egg-shaped capsules with a conical lid are often present. The seta is roughened.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 5
      },
      {
        NAME: "Orthotrichum anomalum",
        COUNT: 65,
        COUNTS: 4,
        COMMON: "Anomalous Bristlemoss",
        DESC: "O. anomalum differs from most British members of the genus in growing on rocks or masonry rather than trees. The dark reddish-brown ripe capsules of O. anomalum are held well above low cushions of straight-leaved, green or brown shoots on a 2–4 mm long seta: a distinctive appearance not shared by other common mosses of the lowlands, except Ulota species that grow on trees and shrubs. Each capsule has 16 erect outer peristome teeth and strong ribs when it is dry. Mature capsules are reddish-brown, but light green when unripe. The calyptra is light brown and is sparsely hairy. Shoots are typically about 1.5 cm tall, with leaves 2.5–4 mm long, and capsules about 2 mm long.",
        ORDER: "Orthotrichales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 2
      },
      {
        NAME: "Pohlia melanodon",
        COUNT: 65,
        COUNTS: 4,
        COMMON: "Pink-fruited Threadmoss",
        DESC: "P. melanodon forms scattered shoots or tufts, up to about 1 cm tall, with delicate-looking, pale green leaves and reddish stems. Upper leaves are about 1.5 mm long; lower leaves are less than 1 mm long. The prominent nerve ceases below the leaf tip.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 7
      },
      {
        NAME: "Racomitrium fasciculare",
        COUNT: 65,
        COUNTS: 4,
        COMMON: "Green Mountain Fringemoss",
        DESC: "The sprawling growth form, with shoots several (up to 10) centimetres long, and short branches with bunched leaves are the most distinctive features of R. fasciculare.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 2
      },
      {
        NAME: "Funaria hygrometrica",
        COUNT: 64,
        COUNTS: 4,
        COMMON: "Bonfire Moss",
        DESC: "This is a common plant in lowland Britain and is one that beginners will soon learn to recognize. The short (3–10 mm) shoots of this moss form loose carpets. The egg-shaped leaves vary in size (2–4 mm long) and are translucent, with very large, lax cells, easily seen with a ×10 hand lens. Asymmetrical capsules are usually present in abundance, borne on a long (3–5 cm), swan-neck seta, with a large, delicate calyptra and a convex lid.",
        ORDER: "Funariales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Orthodontium lineare",
        COUNT: 64,
        COUNTS: 4,
        COMMON: "Cape Threadmoss",
        DESC: "This species forms fine, sometimes extensive tufts or patches up to 1 cm tall. The leaves, up to 3 mm long, are very fine with plane margins, wavy and with a slight sheen when dry, often weakly curved in one direction when moist. Capsules, which gradually taper into a seta about 5 mm long, are freely and often abundantly produced in late spring. When green and young, they are held at an oblique angle with a characteristically upturned beak. The mature and empty capsules turn reddish-brown, are erect and become distinctly furrowed. Both leaves and setae point down below the horizontal in a characteristic manner.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Dichodontium palustre",
        COUNT: 63,
        COUNTS: 4,
        COMMON: "Marsh Forklet-moss",
        DESC: "Shoots of this distinctively light green species may grow to several centimetres in length, but small plants may barely reach 1 cm in height. The erect stems have leaves typically 2.5–3.5 mm long, with a broad base which sheaths the stem. The upper part of the leaf curves away from the stem, giving the shoots a characteristic appearance.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Homalothecium sericeum",
        COUNT: 62,
        COUNTS: 4,
        COMMON: "Silky Wall Feathermoss",
        DESC: "The green or golden green main shoots grow closely appressed to the substrate, sometimes reaching many centimetres in length. They have short (less than 1 cm), crowded side branches that curve upwards and inwards when dry, with leaves closely appressed. On wetting, the branches rapidly straighten and the leaves spread outwards. Leaves are 2.5–3 mm long, strongly pleated, narrowly spearhead-shaped, widest at the base, and taper evenly to a finely pointed tip. The margins are weakly toothed. Capsules are fairly frequent, 2–3 mm long, straight and cylindrical.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 3
      },
      {
        NAME: "Bryum pseudotriquetrum",
        COUNT: 61,
        COUNTS: 4,
        COMMON: "Marsh Bryum",
        DESC: "The shoots of this relatively large Bryum form green to reddish or brown tufts and patches up to several centimetres tall. The stems are often reddish, and this colouring may extend onto the leaves, which are equally spaced along the stem, 2–3.5 mm long, with a border of narrow cells and a thick nerve that is usually only shortly excurrent. Most plants have leaves with a base that runs down onto the stem, a feature shared with few other Bryum species, and hence important for identification, although this feature is not always well-developed. The lower part of the stems is covered with a brown mat of rhizoids.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "R",
        LIGHT: 8,
        MOISTURE: 9
      },
      {
        NAME: "Fissidens bryoides",
        COUNT: 61,
        COUNTS: 4,
        COMMON: "Lesser Pocketmoss",
        DESC: "This is the commonest of a number of Fissidens species which have the leaves bordered by long, narrow cells; this pale glistening border can be seen with a good hand lens. Shoots are 3–20 mm long. The male organs are borne on very short lateral branchlets; these can usually be seen as a number of bud-like structures in the leaf axils when a shoot is held up to the light. Capsules are frequent and erect; the seta arises terminally on the shoot.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Ulota bruchii",
        COUNT: 61,
        COUNTS: 4,
        COMMON: "Bruch’s Pincushion",
        DESC: "These mosses form yellowish-green cushions 0.5–1 (–2) cm tall, with a blackish-brown lower part to each shoot. The upper leaves of U. bruchii are 2.5–4 mm long, while those of U. crispa are 2–3.5 mm long; however, there is considerable overlap in this and other features of the two species, and some plants cannot be confidently named without microscopical examination of the peristome.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 5
      },
      {
        NAME: "Ulota phyllantha",
        COUNT: 60,
        COUNTS: 4,
        COMMON: "Frizzled Pincushion",
        DESC: "U. phyllantha forms pale cushions 1–3.5 cm tall, olive-green above and reddish-brown or almost black below. The leaves are 2.5–4.5 mm long and are straight when moist, but curl up when dry. Each has a brownish nerve that protrudes from the tip, and this supports a conspicuous cluster of brown gemmae on most of the upper leaves of each shoot. Capsules are very rare in spring and summer.",
        ORDER: "Orthotrichales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Sphagnum palustre",
        COUNT: 57,
        COUNTS: 4,
        COMMON: "Blunt-leaved Bogmoss",
        DESC: "S. palustre is rather variable in colour, forming large, untidy mats or loose hummocks that are green to yellow-brown, with or without a contrasting capitulum centre. The most distinctive plants have capitula with the centre arched above the outer part, the centre salmon-pink to brick-red or dark brown (especially in the autumn and winter), contrasting with paler spreading branches. Spreading branches in the outer part of the capitulum and just below are usually elongated and narrowly tapering.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Amblystegium serpens",
        COUNT: 56,
        COUNTS: 3,
        COMMON: "Juratzka’s Feathermoss",
        DESC: "The mid-to dark green, irregularly branched, 1–2 cm long shoots may form extensive, intricate patches. Stem leaves are very small (normally only about 0.5 mm long), erect or erect-spreading, narrowly egg-shaped, with a tapering tip, and often rather markedly narrowed at about mid-leaf. The nerve is single, but difficult to see with a hand lens, and does not extend beyond mid-leaf. Branch leaves are very similar, but even smal er. Smal forms in saline coastal habitats (var. salinum) have a short nerve, but this is difficult to see in the field. Capsules are common, to about 2 mm long, curved and cylindrical, borne on a long seta, and have a conical lid. The calyptra is white.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Didymodon fallax",
        COUNT: 54,
        COUNTS: 3,
        COMMON: "False Beardmoss",
        DESC: "D. fallax grows in loose tufts, patches or as scattered shoots. Shoots are short (0.75–",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Schistidium crassipilum",
        COUNT: 54,
        COUNTS: 3,
        COMMON: "Thickpoint Grimmia",
        DESC: "This is by far the commonest Schistidium in lowland Britain, and is the only member of the genus likely to be found in much of England. It grows as rounded cushions or flat patches 1–3 cm tall. These usually look hoary owing to the presence of a hair point at the tip of the leaves. Lower leaves are about 1.75–2.25 mm long; those surrounding the capsules may exceed 3 mm. The capsules, largely hidden by the leaves that sheath them, are characteristic of Schistidium and distinguish the genus from other hoary mosses on walls.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 1
      },
      {
        NAME: "Sphagnum subnitens",
        COUNT: 54,
        COUNTS: 3,
        COMMON: "Brownish Bogmoss",
        DESC: "Forms moderately dense cushions and small hummocks. The capitula are usually less than 2 cm in diameter, much smaller in dry or exposed sites. The outer branches of the capitula and upper stem branches are long, making shoots look top-heavy. In denser cushions, these branches turn upwards and grow over the capitulum centre.",
        ORDER: "Sphagnales",
        HABITAT: "HARD ROCK",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Sciuro-hypnum plumosum",
        COUNT: 53,
        COUNTS: 3,
        COMMON: "Rusty Feathermoss",
        DESC: "B. plumosum is medium-sized to fairly large, and sometimes forms extensive patches.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 8
      },
      {
        NAME: "Sphagnum squarrosum",
        COUNT: 52,
        COUNTS: 3,
        COMMON: "Spiky Bogmoss",
        DESC: "Robust, bright green, spiky-looking plants. Branch leaves, wide in the basal half, are abruptly contracted to a pointed, tapering, tubular tip, which is distinctly curved away from the branch. The terminal bud is large and conical, immersed or slightly projecting above the rest of the capitulum. Stem leaves are large, rectangular, broad across the tip, and weak and floppy. Capsules are common.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 9
      },
      {
        NAME: "Encalypta streptocarpa",
        COUNT: 51,
        COUNTS: 3,
        COMMON: "Spiral Extinguisher-moss",
        DESC: "This moss forms relatively large, dull, pale green patches. Shoots are typically 1–2 cm tall, with leaves 4–7 mm long. The broad, more or less parallel-sided, opaque, very matt leaves narrow abruptly to a blunt, rounded tip, with the nerve ending in or just below the tip. Clusters of brown, thread-like propagules often occur in the leaf axils. Capsules are rarely present. They are spirally ribbed, have a peristome, and until maturity are entirely covered by the very large calyptra. This is the commonest species of Encalypta, but the only one in which capsules are rare.",
        ORDER: "Encalyptales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "F",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Dicranella rufescens",
        COUNT: 50,
        COUNTS: 3,
        COMMON: "Rufous Forklet-moss",
        DESC: "When mature, the 3–8 mm tall stems of this small plant are reddish, at least below. They often contrast with the stiff, yellow-green leaves, although these may also develop reddish-brown tints. The leaves, typically 1–2 mm long, are narrow throughout their length (lacking a sheathing base) and when moist are characteristically all bent over to one side of the stem. They have plane margins and taper gradually to an acute tip. Seta, capsule and peristome are red; the capsule is erect or held at only a very slight angle from the vertical.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Fissidens taxifolius",
        COUNT: 48,
        COUNTS: 3,
        COMMON: "Common Pocketmoss",
        DESC: "F. taxifolius is a medium-sized species, with shoots up to 2 cm long. The leaves lack a border, and the nerve runs right to the tip of the leaf, where it is usually excurrent as a short point. Under a microscope the leaf margins are regularly and finely toothed, but this is scarcely detectable in the field. Capsules are fairly frequent, inclined, and the red seta arises from near the base of the main shoot. Var. taxifolius has more or less parallel-sided leaves which taper abruptly to an acute and often abruptly pointed tip.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Pseudoscleropodium purum",
        COUNT: 48,
        COUNTS: 3,
        COMMON: "Neat Feathermoss",
        DESC: "This is one of the easiest mosses to recognize in the field. It is a robust, green or yellow-green plant with more or less regularly pinnate shoots to 10 cm or more long, and relatively short branches (the shoots are therefore feather-like). The leaves are erect, loosely appressed and overlapping, only a little longer than wide, and deeply concave. This gives the typically 2 mm wide shoots a stout, fat appearance. The leaves are about 2 mm long, broadly rounded or broadly pointed, and their most distinctive feature is the presence of a small, recurved point at the tip. At the tip of the stem and new branches, the crowded points of the leaves protrude like a miniature crown.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Atrichum crispum",
        COUNT: 44,
        COUNTS: 3,
        COMMON: "Fountain Smoothcap",
        DESC: "The obscure ridges of tissue on the nerve and relatively short, broad leaves make A. crispum look rather different from other Atrichum species. It forms pale to dull, olive-green tufts or patches, with individual shoots up to 7 cm tall, but generally about half this height. The leaves are held away from the stem, 4–6 mm long, distinctly narrowed at the base and scarcely undulate when moist; they become crisped when dry. The margins have single (very rarely paired) teeth more or less from the base to the acute tip, but unlike other Atrichum species, the underside of the leaf is tooth-free. The nerve has 1–3 low and obscure ridges of tissue on its upper side.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Plagiothecium succulentum",
        COUNT: 43,
        COUNTS: 3,
        COMMON: "Juicy Silkmoss",
        DESC: "These common and closely related species have sparsely branched shoots arranged in one plane. The leaves are 2–3.2 mm long, egg-shaped to narrowly egg-shaped, and are mostly more or less symmetrical. The nerve is weak and double, although it may reach as far as mid-leaf. P. nemorale is typically a dark, dull green, whereas P. succulentum is typically golden green and glossy, but confirmation requires microscopical examination of the leaf cells (broader in shape and tending to be in transverse rows in P. nemorale, and narrower and more overlapping in P. succulentum) although something of this difference can be discerned with a ×20",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "F",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Straminergon stramineum",
        COUNT: 43,
        COUNTS: 3,
        COMMON: "Straw Spearmoss",
        DESC: "S. stramineum often grows as scattered stems among other vegetation or forms lax tufts or patches. Shoots are pale green (never reddish) and medium-sized, commonly 2–8 cm long, but sometimes more, and hardly branched. They have a string-like appearance because the leaves are slightly concave and overlap each other (though not always closely). The leaves are broadly or narrowly egg-shaped, about 1 mm wide, with a rounded tip, and have a long, single nerve extending well above mid-leaf, sometimes nearly to the tip. A distinct patch of cells in the basal corners of the leaves does not extend all the way to the nerve.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Solitary",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Hygrohypnum ochraceum",
        COUNT: 42,
        COUNTS: 3,
        COMMON: "Claw Brook-moss",
        DESC: "H. ochraceum is best recognized in the field by its combination of habitat (swift-running streams) and form (concave leaves which are egg-shaped and distinctly curved in the upper part). Plants are medium-sized, with irregular pinnate branching, the branches normally prostrate and parallel with the stem because they grow in and near running water. It typically forms large, soft, green or brownish patches with stems 2–10 cm long. The larger leaves are about 1.5–2 mm long, oblong or broadly spearhead-shaped, with a fairly wide, blunt tip. The nerve is variable, often short and double and therefore indistinct, sometimes longer and single.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 10
      },
      {
        NAME: "Dicranella varia",
        COUNT: 39,
        COUNTS: 3,
        COMMON: "Variable Forklet-moss",
        DESC: "The short (2–10 mm), erect shoots of D. varia bear narrow, rather stiff, bright green or yellowish-green leaves, just less than 2 mm long, which are sometimes curved to one side of the stem. They lack an expanded base, have recurved margins and taper to an acute tip. The leaves surrounding the base of the seta are similar to the leaves below. The species fruits freely in damp habitats, having a reddish seta and purplish-red capsules which are inclined at an angle to the vertical; the bright red lid is conspicuous.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Hyocomium armoricum",
        COUNT: 39,
        COUNTS: 3,
        COMMON: "Flagellate Feathermoss",
        DESC: "A green to golden brown, pinnately branched moss of streamsides. Typical shoots are 3–4 cm long, but may be longer. The rather crowded leaves spread away from the stem. Leaves are 1–1.5 mm long. Stem leaves are broadly triangular to egg-shaped, rapidly narrow to a sharp point, and are somewhat pleated and undulate, giving a crumpled appearance. The finely toothed margins can be seen with a ×20 hand lens, and the nerve is short and double. Branch leaves are spearhead-shaped. Usually the leaves do not point in any particular direction, but may occasionally point somewhat in one direction. Capsules are rare; the seta is roughened.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 8
      },
      {
        NAME: "Orthotrichum pulchellum",
        COUNT: 39,
        COUNTS: 3,
        COMMON: "Elegant Bristlemoss",
        DESC: "A distinctive little Orthotrichum with twisted leaves when dry, which grows in loose, slightly branched, yellowish-green tufts that are usually less than 1 cm tall, but may grow to about 2 cm in height. Leaves are 2–2.5 mm long. Unlike most other members of the genus, O. pulchellum holds its 1.5 mm long capsules clear of the leaves on a seta 1–2 mm long. These capsules are pale red-brown when old and dry, and have 8 reflexed, orange peristome teeth; when unripe, they are covered by an almost hairless, pale calyptra tipped with dark brown and with a series of dark dots around the lower margin.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 2,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Thuidium tamariscinum",
        COUNT: 39,
        COUNTS: 3,
        COMMON: "Common Tamarisk-moss",
        DESC: "The bright, yellowish-green or dark green shoots of T. tamariscinum are amongst the most distinctive of our pleurocarps. They are usually tripinnately branched, 5–25 cm long, and form loose mats. The green or red-brown stems are covered with a felt of tiny, branched filaments and very broad, heart-shaped or triangular, opaque, longitudinally ridged, acute-tipped leaves, about 1.25 mm long. The nerve is wide and almost reaches the leaf tip. Branch leaves are narrower and shorter (up to 0.5 mm). The branches are arranged more or less in one plane and become shorter towards the end of the shoot. Capsules are uncommon, and form in autumn and winter.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Campylopus pyriformis",
        COUNT: 38,
        COUNTS: 3,
        COMMON: "Dwarf Swan-neck Moss",
        DESC: "In short, untidy, dense, yellow-green to mid-green turfs and spreading patches to 3 cm tall, but usually less than 1 cm. Patches are often covered with deciduous leaves or shoot tips. The leaves are 2.5–7.5 mm long, erect and more or less straight when moist, and the longer upper leaves become somewhat wavy when dry. The nerve is wide, filling up to 50% of the leaf base, the basal cells are colourless and the basal marginal cells do not usually form distinct patches. Capsules are occasional on a wavy seta which may curve down so that the capsule is hidden amongst the leaves.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Tetraphis pellucida",
        COUNT: 38,
        COUNTS: 3,
        COMMON: "Pellucid Four-tooth Moss",
        DESC: "Forms rather short (up to 1.5 cm), upright tufts or loose, wide patches composed of slender, delicate, individual shoots. Moist patches are yellow-green, but they take on a slightly bluish-green metallic sheen when dry. The leaves are held away from the stem when moist – the lower leaves are 1 mm or a little longer, circular to egg-shaped, often irregularly shaped and distant, those above are up to 2 mm long, more crowded, narrowly egg-shaped – and have a shortly pointed tip and plane, entire margins. The nerve ends wel below the tip. Non-fertile shoot tips often have gemma cups formed from larger, crowded leaves, within which sit many disc-shaped gemmae.",
        ORDER: "Tetraphidales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "F",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Brachythecium albicans",
        COUNT: 37,
        COUNTS: 3,
        COMMON: "Whitish Feathermoss",
        DESC: "B. albicans is a distinctive moss because of its pale whitish-green or yellow-green, string-like shoots. The plants are sparsely branched, commonly 2–5 cm long, with tall, mostly erect branches. Their string-like appearance is due to the long but rather slender branches (to about 1 mm wide) and the leaves being appressed and closely overlapping, both when moist and dry. These are egg-shaped, about 1.5–2 mm long, with a long, fine tip and a single nerve ceasing above mid-leaf. The tip, unlike the rest of the leaf, tends to spread slightly outwards, or less often is slightly curved to the side. The leaf surface is slightly pleated, but this is not always very obvious.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 3
      },
      {
        NAME: "Climacium dendroides",
        COUNT: 37,
        COUNTS: 3,
        COMMON: "Tree-moss",
        DESC: "C. dendroides often grows in patches, with erect stems 2–3 cm tall, arising from the prostrate, usually hidden, rhizome-like primary stems. The individual shoots resemble miniature palm trees, with rather rigid, stubby, yellow-green branches at the tip of the stems. The erect stems may be very short in dry sites, whereas shoots are much more tree-like in moister places. Leaves are about 2–3.5 mm long. The stem leaves are well-spaced and rounded at the tip; the branch leaves are narrower, acute, coarsely toothed near the tip and often have longitudinal folds; the leaf cells are elongated. Capsules are rare because male plants appear to be much less frequent than females.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Dendroid",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Pleurozium schreberi",
        COUNT: 37,
        COUNTS: 3,
        COMMON: "Red-stemmed Feathermoss",
        DESC: "The loosely pinnate branches and bright red stem showing through translucent green leaves are usually easy to recognize. When dry, the red stems only become visible on wetting, or after scraping leaves off the stem. Shoots are several centimetres long.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Ptychomitrium polyphyllum",
        COUNT: 37,
        COUNTS: 3,
        COMMON: "Long-shanked Pincushion",
        DESC: "This is a medium-sized to rather robust (shoots up to about 4 cm tall) pincushion species, with leaves strongly crisped when dry. The leaves are about 4 mm long and narrowly spearhead-shaped. They are coarsely but distantly toothed above, the teeth being easily visible under a ×20 hand lens. Capsules are common, large, rather elongated, held on a long (7 mm, or occasionally shorter) seta and equipped in the spring with long, straight peristome teeth that are shed later in the summer.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 3
      },
      {
        NAME: "Ulota crispa",
        COUNT: 37,
        COUNTS: 3,
        COMMON: "Crisped Pincushion",
        DESC: "These mosses form yellowish-green cushions 0.5–1 (–2) cm tall, with a blackish-brown lower part to each shoot. The upper leaves of U. bruchii are 2.5–4 mm long, while those of U. crispa are 2–3.5 mm long; however, there is considerable overlap in this and other features of the two species, and some plants cannot be confidently named without microscopical examination of the peristome.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Syntrichia ruralis",
        COUNT: 36,
        COUNTS: 3,
        COMMON: "Sand-hill Screw-moss",
        DESC: "Shoots are up to several centimetres long, but often partly buried in sand. They are yellowish-green to golden brown when moist, and golden brown when dry.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 3
      },
      {
        NAME: "Aulacomnium androgynum",
        COUNT: 35,
        COUNTS: 3,
        COMMON: "Bud-headed Groove-moss",
        DESC: "A. androgynum forms small, pale, dull green tufts. Many shoots terminate in an elongated stalk with a ball of gemmae at the top. Shoots are 3–4 mm tall (excluding the elongated stalk and ball of gemmae). The leaves appress and overlap each other, are typically 1–2 mm long, and broadly spearhead-shaped, shortly pointed and not shiny. Capsules are very rare.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Cryphaea heteromalla",
        COUNT: 35,
        COUNTS: 3,
        COMMON: "Lateral Cryphaea",
        DESC: "The primary stems of C. heteromalla are tightly appressed to bark, whereas its more conspicuous secondary stems project stiffly away from it. Typical shoots grow to about 1.5 cm long. The leaves are 1–1.3 mm long, held close to the stems when dry, and spread only slightly when moist. They have an obvious nerve which extends to well over half their length, and an acute tip. Several capsules occur in close proximity to each other along just one side of the mature secondary stems. They are 2.5–3 mm long, and have a very short seta.",
        ORDER: "Hypnales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Palustriella commutata",
        COUNT: 35,
        COUNTS: 3,
        COMMON: "Curled Hookmoss",
        DESC: "Typical shoots are green or yellowish-brown, 4–6 cm long or more, with a densely and regularly pinnate pattern of branching. This branching looks rather feather-like, but calcareous deposits on the shoots make them feel stiff and rough. The stem is clothed with tiny leaf-like structures and red-brown rhizoids which make the stem look fuzzy. The triangularly heart-shaped stem leaves are 2–2.5 mm long, pleated, and have a very stout nerve that extends to the long, fine tip. The cells in the basal angles are coloured, but may be difficult to see without a microscope. The strongly curved branch leaves are much smaller (up to about 1.5 mm). Capsules are rare.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Pohlia wahlenbergii",
        COUNT: 35,
        COUNTS: 3,
        COMMON: "Chalk Threadmoss",
        DESC: "The shoots of this moss are distinctively pale glaucous green or almost white, with red stems, and vary in size, typical shoots being 1–3 cm tall. Leaves are approximately 2 mm long. Pear-shaped, pendulous capsules form rarely in summer. P. wahlenbergii var. glacialis may grow up to as much as 15 cm tall. P. wahlenbergii var. calcarea is smaller (up to 1.5 cm tall), with narrower (0.5 mm wide) leaves.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Isothecium myosuroides",
        COUNT: 34,
        COUNTS: 3,
        COMMON: "Slender Mouse-tail Moss",
        DESC: "I. myosuroides has a distinctly tree-like growth form, its main stems growing away from the substrate, unbranched in the lower part, and bushily branched above. It often occurs in pure, dense mats, so its tree-like form may not be immediately apparent.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Dendroid",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Oxyrrhynchium hians",
        COUNT: 32,
        COUNTS: 3,
        COMMON: "Swartz’s Feathermoss",
        DESC: "O. hians varies greatly. Some forms are yellow-green, prostrate, with straggling main stems and widely spaced side branches. It also occurs in denser, dull or dark green patches. More rarely the branches are crowded and erect. Plants are medium-sized and have branches that usually spread widely from the main stems, which are usually about 1–4 cm long. Stem leaves are a little larger than branch leaves, but similar in shape, broadly egg-shaped with a broadly pointed to tapering tip, 1–1.5 mm long.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Sphagnum russowii",
        COUNT: 32,
        COUNTS: 3,
        COMMON: "Russow’s Bogmoss",
        DESC: "S. russowii is a medium to large plant, found in soft hummocks or loose carpets.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 7
      },
      {
        NAME: "Sphagnum papillosum",
        COUNT: 31,
        COUNTS: 3,
        COMMON: "Papillose Bogmoss",
        DESC: "S. papillosum forms mats and low hummocks. The whole plant is typically pale ochre-brown, but can be green or yellowish. There is never any trace of red. The capitulum centre and spreading branches are always a similar colour. Fascicles have 2 spreading and 1 or 2 pendent branches. Upper spreading branches are short and blunt-tipped. Branch leaves are often distinctly spreading at an angle of 45–90° to the branch. Capsules are occasional.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 8
      },
      {
        NAME: "Fissidens adianthoides",
        COUNT: 28,
        COUNTS: 3,
        COMMON: "Maidenhair Pocketmoss",
        DESC: "These two robust species have shoots usually reaching 4–5 mm wide and up to about 6 mm long. The larger teeth of the irregularly toothed leaf margins are detectable with a ×20 hand lens. There is no border of elongated cells, but several rows of leaf cells form a marginal band which is slightly more pellucid than the rest of the leaf blade.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Hygrohypnum luridum",
        COUNT: 28,
        COUNTS: 3,
        COMMON: "Drab Brook-moss",
        DESC: "H. luridum is very variable, forming irregular patches with prostrate to erect branches. Plants vary from slender shoots on moist rock to robust plants on boulders in streams. The leaves are curved (sometimes strongly) and concave, often with the margins somewhat incurved towards the tip. They vary in shape from broadly egg-shaped with a blunt tip to narrowly egg-shaped with an acute tip, about 1–1.5 mm long. They usually have a single nerve; this may extend almost to the leaf tip. Egg-shaped capsules 2 mm long are often present, and raised on an elongated seta.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 9
      },
      {
        NAME: "Hypnum andoi",
        COUNT: 28,
        COUNTS: 3,
        COMMON: "Mamillate Plaitmoss",
        DESC: "This is the commonest Hypnum on rock and bark in many upland districts of Britain. The leaves vary from 0.75 to about 1.75 mm in length, are strongly curved towards the underside of the shoot, and gradually taper to a fine point. Shoots are irregularly branched, and yellow-green to dull green, without any trace of the warm, golden brown tints sometimes found in H. cupressiforme and which are often conspicuous in H. lacunosum. The shoots can be medium-sized (up to about 1.5 mm wide), but are frequently slender, especially when growing on steep surfaces.",
        ORDER: "Hypnales",
        HABITAT: "ON WOOD",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 5
      },
      {
        NAME: "Sphagnum cuspidatum",
        COUNT: 28,
        COUNTS: 3,
        COMMON: "Feathery Bogmoss",
        DESC: "Medium or large shoots, occurring in carpets or as a scattered submerged aquatic.",
        ORDER: "Sphagnales",
        HABITAT: "BOGS",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 10
      },
      {
        NAME: "Thamnobryum alopecurum",
        COUNT: 27,
        COUNTS: 3,
        COMMON: "Fox-tail Feathermoss",
        DESC: "This is about the largest of our tree-like mosses (3–6 mm tall), and typical plants do indeed resemble miniature trees. The upright stems bear small (less than 2 mm long), triangular, scale-like leaves whereas the branches have dark green leaves 1.5–2.5",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Dendroid",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Rhytidiadelphus loreus",
        COUNT: 26,
        COUNTS: 3,
        COMMON: "Little Shaggy-moss",
        DESC: "This robust (shoots often 15–20 cm long), irregularly pinnate, spreading moss has a red stem. The leaves are approximately 3 mm long and have a broad, oval base, which narrows to a long, tapering tip. The leaves are broadly spreading and curved, and all point more or less in the same direction. The leaf has lightly toothed margins and a short, double nerve. The surface is pleated. Fertile stems are not uncommon, and the 2 mm long, curved capsule is borne on a red seta about 3 cm long.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 5,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Ctenidium molluscum",
        COUNT: 25,
        COUNTS: 3,
        COMMON: "Chalk Comb-moss",
        DESC: "This very variable moss forms soft, closely branched, loose, yellowish-green patches.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Pohlia annotina",
        COUNT: 25,
        COUNTS: 3,
        COMMON: "Pale-fruited Threadmoss",
        DESC: "P. annotina is a small (about 0.75–1 cm tall), delicate-looking, pale green moss with many (usually 3 to about 20) light green bulbils in each of the leaf axils on the upper part of the shoots. These bulbils are less than 0.5 mm long, vary greatly in shape, and are visible to the naked eye when they form clusters in the leaf axils.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Grimmia trichophylla",
        COUNT: 24,
        COUNTS: 3,
        COMMON: "Hair-pointed Grimmia",
        DESC: "G. trichophylla is common in the north and west, forming light to yellow-green, round cushions or loose patches to 1 cm or taller, with shoots up to 3.5 cm long and with leaves 2–3 mm long. The younger (upper) leaves are lighter green than the lower leaves. The nerved leaves are narrow, recurved at the margins and taper towards the tip which terminates in a conspicuous, but variably long, white hair point. When moist, the leaves spread, giving a spiky appearance. Dry leaves twist, becoming spirally arranged and slightly contorted, and the wavy hair points become more prominent.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 7,
        MOISTURE: 1
      },
      {
        NAME: "Brachytheciastrum velutinum",
        COUNT: 23,
        COUNTS: 3,
        COMMON: "Velvet Feathermoss",
        DESC: "B. velutinum is a common moss in lowland Britain. The shoots are slender to medium-sized, and form loose to rather dense, green patches. They are irregularly to more or less pinnately branched, with short branches. The stem leaves are commonly 1–1.5 mm long, and narrowly triangular, i.e. widest just above the base and evenly tapered to an acute or longly tapering tip. However, some forms have narrowly spearhead-shaped leaves. The leaves spread somewhat, and are often slightly curved, particularly near the shoot tip. The single nerve is fairly strong, but ceases below the tip. Branch leaves are smaller and narrowly egg-shaped.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Hylocomium splendens",
        COUNT: 23,
        COUNTS: 3,
        COMMON: "Glittering Woodmoss",
        DESC: "This glossy, bright green, robust moss has regularly arranged, branched branches (bipinnate) and a red stem. Shoots are several to 10 or even 20 cm long. A ‘flight of steps’ appearance to the shoots is a consequence of varying rates of growth during successive seasons from a bud behind the shoot tip. Stem leaves are quite large, 2.5–3 mm long, and oval with a long, tapering tip. Branch leaves are smaller (1 mm long), more concave and have a shorter tip. Both types of leaf have a short, double nerve (or may lack a nerve) and sharply toothed margins in the upper half. Under a hand lens, the stems and branches appear furry owing to the presence of branched filaments.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Oligotrichum hercynicum",
        COUNT: 23,
        COUNTS: 3,
        COMMON: "Hercynian Haircap",
        DESC: "A small, distinctive moss, whose short (0.5–3 cm), upright, scattered stems are usually quite vividly green; they become duller and less obvious when dry. The incurving leaves, up to 5 mm long when lax and shaded, but usually shorter, are awl-shaped, with a broader sheathing base. The upper surface has about 12 rather wavy ridges of tissue, which are partly covered by strongly inrolled margins, giving the leaf a solid appearance. The leaves become even more inrolled and curved as the plant dries. O. hercynicum is dioicous, and male plants are smaller than females.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Plagiothecium denticulatum",
        COUNT: 23,
        COUNTS: 3,
        COMMON: "Dented Silkmoss",
        DESC: "P. denticulatum has leaves arranged in one plane. Its sparingly branched shoots are often light green, translucent and noticeably glossy, although darker and less glossy plants can also occur. The leaves are about 1.5–2.5 mm long and distinctly asymmetrical in shape, with one side more strongly curved than the other.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "F",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Warnstorfia fluitans",
        COUNT: 23,
        COUNTS: 3,
        COMMON: "Floating Hookmoss",
        DESC: "This lax, straggling, dingy, dark green pleurocarp lacks red tones. Its leaves are always curved, but seldom very strongly so. This and its long, irregular branches give W. fluitans a distinctive appearance. Rhizoids are sometimes produced on the leaf tip. Shoots may be many centimetres long, and leaves are 3–5.5 mm long. Curved, cylindrical capsules occasionally form, borne on a seta about 4–8 cm long.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 10
      },
      {
        NAME: "Sanionia uncinata",
        COUNT: 21,
        COUNTS: 3,
        COMMON: "Sickle-leaved Hookmoss",
        DESC: "S. uncinata superficially resembles species of Drepanocladus and Warnstorfia whose leaves point in one direction, but its pale green shoots and very narrow, pleated, strongly curved (forming complete loops) leaves distinguish it from these species. It generally grows upright, with a regularly pinnate branching pattern, but this is often obscured by branches growing over one another, forming untidy patches. Shoots are 3.5–10 cm long, with leaves about 3 mm long. When growing on trees and shrubs S. uncinata sprawls or hangs in wefts. It often produces capsules (2.5 mm long).",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Orthotrichum cupulatum",
        COUNT: 20,
        COUNTS: 3,
        COMMON: "Hooded Bristlemoss",
        DESC: "The capsules of O. cupulatum are produced in the spring, making it readily identifiable for a limited period; the rest of the year it is too easily confused with non-fertile O. anomalum to allow identification. Unripe capsules are light green and contrast with the dark green leaves that surround them; ripe capsules are mid-brown and are furrowed when old and dry. Setae are only 1–1.5 mm long, and there are 16 light green, erect outer peristome teeth. The calyptra is light green, and either sparsely hairy or hairless. Shoots are up to 2 cm long, with leaves 3.5–4 mm long, and capsules about 2 mm long.",
        ORDER: "Orthotrichales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Racomitrium heterostichum",
        COUNT: 20,
        COUNTS: 3,
        COMMON: "Bristly Fringemoss",
        DESC: "Field identification of the R. heterostichum aggregate is unwise as its members are very variable. They grow as loose patches on non-calcareous rocks, especially in dry, sunny places. Shoots are typically 2–4 cm long, with leaves 3–4 mm long. All have long (over 2 mm), narrow capsules on a long seta, and most have hair points, with several branches per stem, but hair-point length and the degree of branching vary.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 2
      },
      {
        NAME: "Rhynchostegium murale",
        COUNT: 20,
        COUNTS: 3,
        COMMON: "Wall Feathermoss",
        DESC: "R. murale forms small or medium-sized, glossy or pale green shoots, the older parts sometimes turning reddish-brown. It is irregularly branched, the branches short and more or less prostrate, usually forming compact patches or growing as scattered shoots among other species. They alter little when dry. The leaves are egg-shaped or oval, about 1 mm or so in length, broadly pointed at the tip and deeply concave.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 5
      },
      {
        NAME: "Eurhynchium striatum",
        COUNT: 19,
        COUNTS: 3,
        COMMON: "Common Striated Feathermoss",
        DESC: "E. striatum is fairly common, and forms cushions or mats that may extend over large areas. Shoots are generally pale or yellow-green, and more or less pinnately branched with branches spreading almost at right angles. The stems and branches are straight, making shoots look rigid. The leaves spread widely and hardly alter on drying, reaching 1.5–2 mm long. They are triangular (almost perfectly so above the base, with straight sides), but narrowed and heart-shaped at the point of attachment, and acute, but not attenuated at the tip. The margins are very finely toothed. A very important character, easily observed with a hand lens, is the wrinkled leaves.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Ulota calvescens",
        COUNT: 19,
        COUNTS: 3,
        COMMON: "Balding Pincushion",
        DESC: "U. calvescens forms small tufts 0.5–1 cm tall, which look very similar to those of our other, commoner Ulota species. Its leaves are about 4 mm long, strongly crisped when dry, and the nerve ends below the tip. A microscope shows that the rather narrow leaf base is deeply and narrowly furrowed near each margin. Capsules form beneath a pale, glossy calyptra that has few hairs, making the dark tip stand out prominently. They are very young in spring and expand by mid-summer, so U. calvescens is most easily spotted in these seasons. The capsules are 1.5–2.5 mm long, and held on a seta 4–6 mm long (the seta is rather longer than in other Ulota species).",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 2,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Orthotrichum lyellii",
        COUNT: 18,
        COUNTS: 3,
        COMMON: "Lyell’s Bristlemoss",
        DESC: "Well-grown O. lyellii is a striking plant, with loose tufts of shoots 3 to 4 cm tall, and dusted all over with brown gemmae. It tends to grow in a characteristic way on tree trunks: sprawling downwards and then curving up at the shoot tip. Poorly grown plants may be less than 1 cm tall, but remain distinctive because of their gemmae and sharply tipped leaves. The leaves are about 3.5 mm long. Capsules are rather rare and have 16 recurved outer peristome teeth.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Pogonatum urnigerum",
        COUNT: 18,
        COUNTS: 3,
        COMMON: "Urn Haircap",
        DESC: "P. urnigerum is a common, glaucous-green moss of gravelly ground in the uplands.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Pseudocrossidium revolutum",
        COUNT: 18,
        COUNTS: 3,
        COMMON: "Revolute Beardmoss",
        DESC: "A small, bright green plant that grows in dense turfs or cushions, up to about 1–1.5 cm tall. The leaves are slightly less than 1.5 mm long, and held upright or slightly spreading on the stems, giving turfs a smooth appearance. When dry, the leaves are tightly curled. Each leaf is somewhat tongue-shaped, tapering gradually to a rather blunt tip from which the nerve protrudes in a short, thick point. A distinctive characteristic of this species is the leaf margins. Instead of just being curved back somewhat, as they are in many species, the leaf margins are rolled back rather like a little scroll.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 3
      },
      {
        NAME: "Blindia acuta",
        COUNT: 17,
        COUNTS: 2,
        COMMON: "Sharp-leaved Blindia",
        DESC: "At first glance, B. acuta looks like a moss in the Dicranales (pp. 340–419). It is a small (shoots usually about 2 cm tall), shiny, dark green or yellowish-green moss with a reddish tinge. The rather rigid leaves are 2–3 mm long, slender and tapering, and often somewhat curved, with conspicuous, orange cells in the basal corners of the leaves. These are visible (with practice) with a ×20 hand lens. The capsules are variable, but are usually more or less egg-shaped and borne on a seta long enough to raise them clear of the leaves (although subsequent branching of the shoots sometimes hides them).",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Orthotrichum stramineum",
        COUNT: 17,
        COUNTS: 2,
        COMMON: "Straw Bristlemoss",
        DESC: "This delightfully neat-looking Orthotrichum species usually grows in rounded cushions 0.5–1 cm tall, topped with abundant capsules that sit just above the level of the leaves. Later in the year, the old, furrowed capsules are dark orange-brown, abruptly narrowed below a wide mouth, and then wide again below. They have 8 reflexed outer peristome teeth, and a microscope reveals immersed stomata. Careful examination with a hand lens should show several long hairs around the base of the seta: an almost unique feature among British Orthotrichum species.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 2,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Seligeria recurvata",
        COUNT: 17,
        COUNTS: 2,
        COMMON: "Recurved Rock-bristle",
        DESC: "The curved seta is the first thing that strikes one about S. recurvata. It is a minute (shoots 1–3 mm tall), brownish plant, growing in thin, bristly mats. Leaves are 1.5–",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Amphidium mougeotii",
        COUNT: 15,
        COUNTS: 2,
        COMMON: "Mougeot’s Yokemoss",
        DESC: "A. mougeotii forms vivid, mid-green, rounded cushions 3–7 cm deep. These can often be recognized from a distance. Each shoot is quite tall, mid-green at the top and orange-brown below, with fairly long (about 2 mm), narrow, sharply pointed leaves.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 7
      },
      {
        NAME: "Bryum pallens",
        COUNT: 15,
        COUNTS: 2,
        COMMON: "Pale Threadmoss",
        DESC: "A variable moss, both in habit and hue, B. pallens is usually salmon-pink or pale rosy-red, but may be brownish or green. It forms patches, tufts, or grows as scattered shoots, typically 1–2 cm tall, but sometimes taller. The upper leaves are more crowded than those below, concave, 1–3 mm long, with a prominent nerve and border, and a pale base, and do not or at most only slightly run down onto the stem.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "O",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Didymodon tophaceus",
        COUNT: 15,
        COUNTS: 2,
        COMMON: "Olive Beardmoss",
        DESC: "Both the shoots and leaves of this species vary considerably in size, according to the conditions in which the moss has been living. It forms olive-brown or brownish tufts or mats, with shoots often only 0.5–1 cm tall, although some populations can grow as much as 3–5 cm in height. Leaves are typically about 2 mm long and quite narrow (less than 1 mm wide), but are tongue-shaped, with nearly parallel sides, so that the tip is usually broadly rounded. The prominent, often reddish nerve ceases below the leaf tip. Dark brown, rather wide-mouthed capsules often form in winter and spring.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "O",
        LIGHT: 5,
        MOISTURE: 8
      },
      {
        NAME: "Drepanocladus aduncus",
        COUNT: 15,
        COUNTS: 2,
        COMMON: "Kneiff’s Hookmoss",
        DESC: "This very variable species is the only common lowland Hook-moss. Two main forms occur, although these are connected by a series of intermediates. One is many centimetres long, dark green, sparsely branched, with about 5 mm long, tapering, straight or slightly curved leaves, and floats in shallow pools and ditches. The other form is lighter green, smaller, upright and well-branched, has strongly curved leaves and favours temporary wetlands. Capsules are very rare.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 10
      },
      {
        NAME: "Orthotrichum striatum",
        COUNT: 15,
        COUNTS: 2,
        COMMON: "Smooth Bristlemoss",
        DESC: "There is a window of opportunity from late winter to early summer during which O. striatum can be identified, thanks to its capsules which are distinctively smooth after they have shed their lid. The capsules are 1.75–2 mm long, and topped by a set of 16 recurved, white outer peristome teeth, as well as 16 straight inner teeth.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Plagiomnium affine",
        COUNT: 15,
        COUNTS: 2,
        COMMON: "Many-fruited Thyme-moss",
        DESC: "P. affine has trailing, non-fertile stems (shoots grow up to 10 cm long), and leaves (5–7 mm long) that longly but narrowly run down onto the stem, and are toothed throughout. The leaf cells are longer than wide, arranged in diagonal rows which can be discerned with a ×20 hand lens. The habitat helps to distinguish P. affine from some similar Plagiomnium species. Capsules are very rare.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Pseudocrossidium hornschuchianum",
        COUNT: 15,
        COUNTS: 2,
        COMMON: "Hornschuch’s Beardmoss",
        DESC: "A small, bright green plant, up to about 1–1.5 cm tall, this species grows in low tufts or patches. Viewed from above, the spreading leaves give the shoots a rather star-like appearance. Individual leaves are slightly over 1 mm long, have a triangular shape, tapering steadily from the base to an acute tip where the nerve extends to make a short point. A distinctive characteristic for this species is to be found in the leaf margins: instead of just being curved back somewhat, as they are in many species, the leaf margins are rolled back rather like a little scroll. This rolling almost reaches the nerve at the leaf tip, and can be seen most clearly on the back of the leaf.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 3
      },
      {
        NAME: "Calliergon cordifolium",
        COUNT: 14,
        COUNTS: 2,
        COMMON: "Heart-leaved Spearmoss",
        DESC: "The erect, little-branched shoots of this medium-sized to large moss are green (or brown below) and may reach 15 cm long or more. Stem leaves are 2–2.5 mm wide, more or less egg-shaped, somewhat heart-shaped at the base, and blunt or rounded at the tip. They often spread outwards from the stem, and have large patches of colourless cells which extend across the whole of the leaf base. However, these are not sharply marked off from the adjacent leaf cells, and are inconspicuous. Branch leaves are smaller and narrower. Capsules are rare.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 10
      },
      {
        NAME: "Orthotrichum tenellum",
        COUNT: 14,
        COUNTS: 2,
        COMMON: "Slender Bristlemoss",
        DESC: "Tufts of O. tenellum are composed of several narrow, upright shoots with appressed leaves, topped by narrow capsules almost completely hidden by a long, sparsely hairy, light green calyptra. The plants are consistently less than 1 cm tall and are often less than 5 mm in height, with leaves 2.5–3 mm long and capsules 2 mm long. Unripe capsules are light green; when ripe or old they become golden brown, and have 8 reflexed, orange outer peristome teeth.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 1,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "O",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Archidium alternifolium",
        COUNT: 13,
        COUNTS: 2,
        COMMON: "Clay Earthmoss",
        DESC: "This small moss grows in dark or mid-green patches or loose mats with stems to 2 cm long, often formed of more or less prostrate, non-fertile shoots with short, widely spaced leaves. Unusually for a moss, the leaves do not increase in size towards the top of the shoots. The leaves are erect or held away from the stem when moist, and are narrowly triangular; the nerve ends in the tip. The occasional, short, fertile shoots have crowded leaves with much larger (2 mm long) leaves surrounding the capsule (see top right photograph) that are more spearhead-shaped, and have a longer, tapering tip. The hidden, spherical capsule is easily overlooked, and does not have a separate lid.",
        ORDER: "Archidiales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Dicranella schreberiana",
        COUNT: 13,
        COUNTS: 2,
        COMMON: "Schreber’s Forklet-moss",
        DESC: "The green or yellowish-green, 2–3 mm long leaves of D. schreberiana have a conspicuously expanded base which clasps the stem (particularly obvious at the stem tip, where the broad upper part of the sheathing base is clearly visible). Above the base, the leaves taper to a long, narrow limb which is often recurved. Shoots are usually somewhat less than 1 cm tall. The species fruits fairly frequently; the seta is purple and the lid of the capsule has a moderately well-developed beak.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Ditrichum heteromallum",
        COUNT: 13,
        COUNTS: 2,
        COMMON: "Curve-leaved Ditrichum",
        DESC: "This small (up to 1 cm tall) moss forms lax, often extensive patches, mixed with other bryophytes. The shoots are normally rather dull yellowish-green, with about 2 mm long leaves that are erect or more often point slightly in one direction –",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Plagiomnium elatum",
        COUNT: 13,
        COUNTS: 2,
        COMMON: "Tall Thyme-moss",
        DESC: "Shoots of this species are up to 10 cm long. The leaves are about 4 mm long, and broadly run down onto the stem at the base. The leaf cells are longer than wide, and arranged in diagonal rows. The non-fertile stems are either erect or curved. Capsules are hardly ever seen in the British Isles.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 9
      },
      {
        NAME: "Pseudephemerum nitidum",
        COUNT: 13,
        COUNTS: 2,
        COMMON: "Delicate Earthmoss",
        DESC: "The stems of P. nitidum are usually no higher than 5 mm and have narrow, gradually tapering mid-green leaves which increase gradually in length from stem base (about 1 mm) to tip (about 2 mm). The nerve is inconspicuous and does not extend as far as the leaf tip. Vegetative plants are therefore both inconspicuous and featureless, but fortunately the plant is abundantly fertile and its fruits develop very rapidly.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Tortula truncata",
        COUNT: 12,
        COUNTS: 2,
        COMMON: "Common Pottia",
        DESC: "This is one of the first (and commonest) mosses that beginners will find in areas of acidic soils. Shoots are clustered or scattered; most are 3–5 mm tall, but some may be much smaller. The broadly oblong leaves are about 2 mm long and widest above the middle, with plane margins and the nerve projecting just beyond the tip. The short (up to 1 mm long) capsules are hardly any longer than wide, typically widest at the rim, and abundant, especially between autumn and spring. They have an obliquely elongated lid, lack a peristome and are borne on a yellowish seta 2–3.5 mm long.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 5
      },
      {
        NAME: "Zygodon conoideus",
        COUNT: 12,
        COUNTS: 2,
        COMMON: "Lesser Yokemoss",
        DESC: "Z. conoideus is the commonest member of the genus in humid woods in valleys in westernmost Britain, where it sometimes clothes the trunks of ash, sycamore and willow trees. Further east, it is commonest on elder, and also occurs on apple trees ( Malus domestica), ash, willows, and other species.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 1,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Sarmentypnum exannulatum",
        COUNT: 11,
        COUNTS: 2,
        COMMON: "Ringless Hook-moss",
        DESC: "W. exannulata is the typical Hook-moss of flushes and poor fens, and usually grows as orange or light green, upright, more or less pinnately branched plants. Shoots are 20–30 cm long, with leaves 2.5–4 mm long. Its moderately curved stem leaves typically have the tip pointing at 90° to the stem. They may be more curved, but seldom form a full circle. Capsules are rare.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 9
      },
      {
        NAME: "Dicranodontium denudatum",
        COUNT: 10,
        COUNTS: 2,
        COMMON: "Beaked Bow-moss",
        DESC: "In glossy, yellow-green to mid-green cushions or spreading patches to 7 cm deep, with deciduous leaves often present on the surface and red rhizoids matting the lower part of the stems. The leaves are typically 5–8 mm long, erect to spreading, usually point in one direction when moist, and are wavy when dry. The leaves have a sheathing base that is egg-shaped and tapers into a long, fine point that is usually finely toothed. The nerve is longly excurrent, smooth at the back above and up to 50% of the width of the leaf base, though it is often rather poorly defined below.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Fontinalis antipyretica",
        COUNT: 10,
        COUNTS: 2,
        COMMON: "Greater Water-moss",
        DESC: "This is our largest aquatic moss, with shoots (1.5–) 5–8 mm wide and often exceeding 15 cm in length. The leaves are 4–5 mm long and strongly folded inwards along the midline, with the fold-line forming a prominent keel. The shoots are usually 3-sided, with the keels forming the angles and the overlapping halves of adjacent leaves forming the sides. The leaf lacks a nerve (though it is not easy to unfold the keel and demonstrate this) and its tip is bluntly pointed and untoothed. Capsules are very uncommon, and almost hidden amongst the leaves, occurring only on plants which have undergone a period of exposure above the water.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 5,
        ARRANGE: "Aquatic",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 12
      },
      {
        NAME: "Pohlia camptotrachela",
        COUNT: 10,
        COUNTS: 2,
        COMMON: "Crookneck Nodding-moss",
        DESC: "P. annotina is a small (about 0.75–1 cm tall), delicate-looking, pale green moss with many (usually 3 to about 20) light green bulbils in each of the leaf axils on the upper part of the shoots. These bulbils are less than 0.5 mm long, vary greatly in shape, and are visible to the naked eye when they form clusters in the leaf axils.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Sphagnum girgensohnii",
        COUNT: 10,
        COUNTS: 2,
        COMMON: "Girgensohn’s Bogmoss",
        DESC: "A medium-sized species, typically found in soft hummocks or extensive carpets.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 8
      },
      {
        NAME: "Campylium stellatum",
        COUNT: 9,
        COUNTS: 2,
        COMMON: "Yellow Starry Feathermoss",
        DESC: "This medium-sized moss of wet ground has erect, pale or yellow-green, sparsely to moderately branched shoots typically 2–3 cm long. Stem leaves are mostly 1.8–",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 8
      },
      {
        NAME: "Discelium nudum",
        COUNT: 9,
        COUNTS: 2,
        COMMON: "Flag-moss",
        DESC: "At first sight, this moss seems to consist only of a capsule on a seta coming directly out of the substrate. On closer examination, the base of the seta is seen to emerge from a few tiny (less than 1 mm long) leaves which grow up from an extensive, green, alga-like mat. This is a persistent protonema, which uniquely forms the main photosynthetic organ of the moss. The nearly spherical capsule (about 1 mm long) is produced on a long seta (up to 2.5 cm); it is initially erect, and becomes horizontal on maturity. Male plants appear as clusters of orange male sex organs surrounded by a few tiny leaves.",
        ORDER: "Funariales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Zygodon viridissimus",
        COUNT: 9,
        COUNTS: 2,
        COMMON: "Green Yokemoss",
        DESC: "These four species – of which Z. viridissimus is the commonest – are difficult to reliably distinguish from each other without checking under a microscope. They all form small (usually up to 1 cm tall), light green tufts and patches. The shortly pointed leaves are held at a wide angle from the stem when moist, giving the plants a characteristically neat appearance. Dry leaves become lightly twisted and appressed to the stem, considerably altering the appearance of shoots. Leaves are typically 1.5–",
        ORDER: "Orthotrichales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "F",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Didymodon luridus",
        COUNT: 8,
        COUNTS: 2,
        COMMON: "Dusky Beardmoss",
        DESC: "Shoots are short (typically 0.5–1 cm tall), forming dark green tufts, sometimes tinged brown. Compared with other members of the genus, the concave leaves of D. luridus are broad relative to their length (about 1.25–1.75 mm long), with a rounded or bluntly pointed leaf tip. When dry, the leaves are held erect and appressed to the stem. Cylindrical capsules are very rare in winter, with short, pale yellowish peristome teeth.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 4
      },
      {
        NAME: "Hookeria lucens",
        COUNT: 8,
        COUNTS: 2,
        COMMON: "Shining Hookeria",
        DESC: "The shoots of H. lucens are 2–6 cm long, pale or bright green, and are rather 2-dimensional, although the flattening is not as extreme as in genera such as Fissidens or Schistostega. The most striking character of the leaves is the enormous, more or less hexagonal cells which are visible to the naked eye and extend to the margins (there is no border of narrow cells). The leaves are about 5 mm long, 3 mm wide, rounded at the tip and have no nerve. The dark brown capsules are quite common, about 2 mm long, borne on a seta about 2 cm tall, and carried horizontally or sloping slightly downwards.",
        ORDER: "Hookeriales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "O",
        LIGHT: 3,
        MOISTURE: 7
      },
      {
        NAME: "Leptodictyum riparium",
        COUNT: 8,
        COUNTS: 2,
        COMMON: "Kneiff’s Feathermoss",
        DESC: "The medium-sized, dingy green, irregularly branched shoots of this rather nondescript moss have stem leaves that are mostly 2–3 mm long, egg-to spearhead-shaped, widest just above the base and tapering evenly to the narrowly pointed tip.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 9
      },
      {
        NAME: "Weissia controversa",
        COUNT: 8,
        COUNTS: 2,
        COMMON: "Green-tufted Stubble-moss",
        DESC: "A variable moss usually less than 1 cm tall, recognized as a Weissia by its shortly oblong, rounded capsules on a relatively long seta, combined with inrolled leaf margins and strongly crisped leaves when dry. Leaves are a little over 2 mm long. All four varieties of W. controversa have relatively wide-mouthed capsules and possess peristome teeth, although careful checking with a hand lens may be needed to find teeth on some plants. Var. controversa grows as open, short patches on soil; var.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Cirriphyllum piliferum",
        COUNT: 7,
        COUNTS: 2,
        COMMON: "Hair-pointed Feathermoss",
        DESC: "This is one of our most easily identified pleurocarps. It is fairly robust, with shoots up to 10 cm or more in length. They are more or less pinnate, with relatively short side branches which spread at right angles to the main stem and are attenuated at the tip.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Dicranum majus",
        COUNT: 7,
        COUNTS: 2,
        COMMON: "Greater Forkmoss",
        DESC: "A large and handsome species, often forming extensive, lax patches. The very long (to 15 mm) leaves are characteristically and uniformly curved (sometimes described as scimitar-shaped) and hardly alter when dry. The leaves are narrowly spearhead-shaped and taper to a long fine tip which is regularly toothed. The nerve, which extends into the tip, is also toothed at the back, but lacks raised lines of cells. In the wetter north and west of Britain, D. majus frequently produces capsules, often several from one shoot, and these have a yellow seta.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Dicranum tauricum",
        COUNT: 7,
        COUNTS: 2,
        COMMON: "Fragile Forkmoss",
        DESC: "Light to mid-green cushions or patches to 4 cm tall, often with broken leaf tips amongst the shoots. Identification can be confirmed by running a moist finger across a tuft. This will invariably bring away leaf fragments on the finger tip. The 3–4 mm long, straight leaves are erect when moist, and more appressed to the stem when dry. The leaves are very narrowly spearhead-shaped, tapering to a very fine tip which is composed largely of nerve and frequently broken off. Capsules are very rare.",
        ORDER: "Dicranales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 4
      },
      {
        NAME: "Fissidens dubius",
        COUNT: 7,
        COUNTS: 2,
        COMMON: "Rock Pocketmoss",
        DESC: "These two robust species have shoots usually reaching 4–5 mm wide and up to about 6 mm long. The larger teeth of the irregularly toothed leaf margins are detectable with a ×20 hand lens. There is no border of elongated cells, but several rows of leaf cells form a marginal band which is slightly more pellucid than the rest of the leaf blade.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Heterocladium heteropterum",
        COUNT: 7,
        COUNTS: 2,
        COMMON: "Slender Tamarisk-moss",
        DESC: "Well-grown H. heteropterum forms shoots up to about 3 cm long. It is dingy, dark green, with roughly pinnate branching, down-curved stem leaves and short nerves (to less than halfway up the leaf). Stem leaves are about twice the size of the branch leaves (about 1 and 0.5 mm long, respectively); both taper to short, acute points.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Platyhypnidium lusitanicum",
        COUNT: 7,
        COUNTS: 2,
        COMMON: "Portuguese Feather-moss",
        DESC: "This green or more often brownish moss of running water in rocky streams usually grows submerged. As in many aquatic mosses, the stems tend to be elongated and sparsely branched, to 10 cm or more long. The leaves are 2–3 mm long, egg-shaped to elliptical, strongly concave, and with a blunt or shortly pointed tip. They do not stand out from the stem, but are erect to appressed and overlapping, making the shoots seem cylindrical. The leaf margins are finely toothed, and the single nerve extends well above mid-leaf. The capsules are similar to those of P. riparioides, but are very rare in most districts.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 11
      },
      {
        NAME: "Scorpidium cossonii",
        COUNT: 7,
        COUNTS: 2,
        COMMON: "Intermediate Hookmoss",
        DESC: "S. cossonii forms relatively small, neat, upright, dark green or red-mottled patches, with shoots up to 2 mm wide. Typical forms have abundant short branches. The leaves are 2–2.5 mm long, and are all turned in one direction. They are wider than those of the similar-looking Warnstorfia exannulata, are not pleated, and so look smooth and shiny. The cells in the basal angles of the leaves are so small and few that they are scarcely visible through a hand lens.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 8
      },
      {
        NAME: "Bryum caespiticium",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Tufted Threadmoss",
        DESC: "The shoots of this moss are normally only 0.5–1 cm tall, with dense tufts of leaves at the upper ends. These densely packed upper leaves are longer (about 3 mm) than those lower down the stem (about 1.5 mm long). The leaves are light, silky green, with an excurrent nerve, and alter little when dry, unlike those of B. capillare (p.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Fontinalis squamosa",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Dixon’s Water-moss",
        DESC: "Typically, F. squamosa is more slender than F. antipyretica, with shoots 1–2 mm wide.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 5,
        ARRANGE: "Aquatic",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 12
      },
      {
        NAME: "Gymnostomum aeruginosum",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Verdigris Tufa-moss",
        DESC: "Dull green cushions, reddish below, between 1 and 8 cm tall. The leaves are 0.75–1.5 mm long, and taper very gradually from an often expanded basal part to a blunt, shortly acute or rounded tip. They are erect to spreading when moist, but incurved and slightly twisted when dry. The nerve, which becomes brownish with age, is broad and strong. Capsules occasionally form in late summer and autumn; they have no peristome.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 8
      },
      {
        NAME: "Plagiothecium nemorale",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Woodsy Silkmoss",
        DESC: "These common and closely related species have sparsely branched shoots arranged in one plane. The leaves are 2–3.2 mm long, egg-shaped to narrowly egg-shaped, and are mostly more or less symmetrical. The nerve is weak and double, although it may reach as far as mid-leaf. P. nemorale is typically a dark, dull green, whereas P. succulentum is typically golden green and glossy, but confirmation requires microscopical examination of the leaf cells (broader in shape and tending to be in transverse rows in P. nemorale, and narrower and more overlapping in P. succulentum) although something of this difference can be discerned with a ×20",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "F",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Pohlia bulbifera",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Blunt-bud Threadmoss",
        DESC: "P. annotina is a small (about 0.75–1 cm tall), delicate-looking, pale green moss with many (usually 3 to about 20) light green bulbils in each of the leaf axils on the upper part of the shoots. These bulbils are less than 0.5 mm long, vary greatly in shape, and are visible to the naked eye when they form clusters in the leaf axils.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Rhytidiadelphus triquetrus",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Big Shaggy-moss",
        DESC: "R. triquetrus is a very large, bushy moss that forms shoots from 5 to 15 or 20 cm long, with irregularly branched, red stems. Whether wet or dry, the leaves stick out in all directions (unlike R. loreus). The leaves, which can be up to 6 mm long, are straight and have a pale, chaffy appearance, giving the shoot a unique, rather untidy character. The leaf has a double nerve, which extends about halfway up the blade, and the margins are lightly toothed. Capsules are rare to occasional.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Sphagnum capillifolium",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Acute-leaved Bogmoss",
        DESC: "S. capillifolium is split into two subspecies, though elsewhere in Europe and North America, these are interpreted as full species. Intermediate forms occur, so not all specimens will be identifiable to subspecies. However, typical examples of the two subspecies differ in several characters, and can be identified in the field. Shoots of both subspecies are small to medium in size. The plants are all or mostly red, except if shaded, when they are green.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Sphagnum flexuosum",
        COUNT: 6,
        COUNTS: 2,
        COMMON: "Flexuous Bogmoss",
        DESC: "A medium-sized species that grows in carpets; green, or with a yellowish tinge; never a strong mustard-brown. Stem and branches are pale, never with any pink.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 9
      },
      {
        NAME: "Bryum archangelicum",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Archangelic Threadmoss",
        DESC: "Bryum archangelicum (synonym: B. imbricatum) usually grows in clearings in grassy vegetation. The habitat and distribution area of Bryum archangelicum and B. algovicum strongly overlap. B. archangelicum seems to be more dependent on natural habitats, and also occurs on humous soil, for example on peaty sand.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 5
      },
      {
        NAME: "Fissidens viridulus",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Green Pocketmoss",
        DESC: "A minute Fissidens with bordered leaves and growing on soil is likely to be one of these two species. The shoots are usually only 1–1.5 mm wide, and fertile shoots are no more than 5 mm tall. The leaf tip is acute with concave sides. These species are part of a difficult complex of species (with F. gracilifolius and F. pusillus), and have to be confirmed by microscopical examination. Differentiated, long leaves around the seta may be a useful pointer for selecting potential F. limbatus for checking (compare with F. gracilifolius, p. 405).",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 5
      },
      {
        NAME: "Mnium stellare",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Starry Thyme-moss",
        DESC: "Shoots are 1–10 cm long. The leaves of M. stellare are 2–3 mm long, broadly egg-shaped with toothed margins, and lack a differentiated border. The contents of dead cells turn dull blue. This is unique in British and Irish mosses, and most striking in dried specimens. Capsules are 1.7 mm long, and very rare.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 2,
        MOISTURE: 6
      },
      {
        NAME: "Palustriella falcata",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Claw-leaved Hookmoss",
        DESC: "P. falcata is very closely related to P. commutata, but without neatly pinnate branching. The branches of P. falcata are fewer and less regular, and the shoots (which typically grow to about 3 cm long) do not have a distinct feather-like shape.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 9
      },
      {
        NAME: "Philonotis calcarea",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Thick-nerved Apple-moss",
        DESC: "The vividly pale green shoots are large, often as tall as 10 cm or more. Leaves are also large (1.8–3 mm long), arranged in rows, and point towards one side of the shoots.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 9
      },
      {
        NAME: "Plagiomnium rostratum",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Long-beaked Thyme-moss",
        DESC: "This species has creeping, non-fertile stems up to about 5 cm long, and leaves 5–7 mm long which do not run down onto the stem. With a ×20 hand lens it is possible to see that the cells are little longer than wide, and are not in clear diagonal rows. Capsules are frequently produced, and the lid is beaked. Capsules frequently form in spring, and are about 4 mm long.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 7
      },
      {
        NAME: "Pohlia drummondii",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Drummond’s Threadmoss",
        DESC: "Shoots are typically 1–2 cm tall, with leaves 1–1.5 mm long. Some (but not all) leaf axils contain a single, large (0.5–1 mm long) brown bulbil, a feature shared only with P. filum (see below). Pear-shaped, pendulous capsules occasionally develop in summer in Scotland.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Polytrichastrum longisetum",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Slender Haircap",
        DESC: "This species forms short to moderately tall (1.5–10 cm) loose tufts, open carpets or solitary, dark greenish shoots. The rather stiff, straight leaves (rarely soft, recurving and laxer when unusually growing in damp places) gradually taper to a finely toothed, brownish point. They are typically somewhat less than 1 cm long, have a distinctly broad, toothed leaf blade, the nerve bearing 20–40 ridges of tissue. The capsule is less acutely 4-to 6-angled than those of its commoner counterparts and is not uncommon in summer. It is only partly covered by the calyptra when mature.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Syntrichia latifolia",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Water Screwmoss",
        DESC: "S. latifolia grows in yellowish-green or dull green, 1–3 cm tall, often silt-encrusted patches which can be quite extensive. The broad (up to 1.5 mm), soft leaves are nearly 3 mm long, and spread when moist, becoming incurved and rather shrivelled when dry. The nerve ends in the broadly rounded leaf tip and the margins are usually plane. The upper surface of the leaf is often strewn with small, spherical gemmae of a similar size and appearance to pollen grains. The cylindrical capsules are rare.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Tortella tortuosa",
        COUNT: 5,
        COUNTS: 1,
        COMMON: "Frizzled Crisp-moss",
        DESC: "T. tortuosa grows in yellow-green tufts or turfs several centimetres in depth. When moist, the long (up to 6–7 mm), narrow leaves have wavy margins. When dry, the leaves shrivel into a distinctive, contorted spiral. Pulling off a few leaves with the fingernails reveals the abrupt V-shaped transition between the colourless basal cells and the upper cells, visible through a hand lens.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Cinclidotus fontinaloides",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Smaller Lattice-moss",
        DESC: "This is one of several robust, dark green mosses that occur on the shores of rivers and lakes. The sparingly branched, somewhat trailing, 2–15 cm long shoots bear large (about 4 mm long), often asymmetrical leaves that are narrowly egg-shaped, and have a strong nerve ending in the tip. The leaf margins are heavily thickened, forming a conspicuous border from base to tip (in older parts of the plant, tattered remnants of border and midrib may be all that survive after abrasion). When dry, the leaves are wavy to spirally twisted. Narrowly elliptically shaped capsules are frequent, but the seta is very short (less than 1 mm), so they are partly buried amongst the leaves.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Aquatic",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Dicranella staphylina",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Field Forklet-moss",
        DESC: "This small plant usually grows in neat clumps of rather crowded stems about 5 mm tall; it is uniformly mid-green, without a reddish or purplish tinge. The translucent leaves are up to 1 mm long, narrowly triangular, with straight sides which taper from the base to an acute tip. The margins are plane or recurved only at the base. The leaves spread out from the stem when moist, showing no tendency to curl over to one side of the stem. The uppermost leaves of fertile plants are noticeably larger than the leaves below, and taper more abruptly from a broader base to a narrow tip. Sexual organs rarely develop and capsules have not been found in the wild in Britain.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 5
      },
      {
        NAME: "Didymodon icmadophilus",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Slender Beardmoss",
        DESC: "Shoots form 1–2 cm tall, olive-green or brown tufts, whose darker colours contrasts with other mosses growing nearby. The leaves are about 1.5–2.5 mm long, with a tip that looks very sharp through a hand lens. Capsules are very rare in Britain, and mature in spring.",
        ORDER: "Pottiales",
        HABITAT: "QUARRIES",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Fissidens osmundoides",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Purple-stalked Pocketmoss",
        DESC: "A medium-sized Fissidens species, with shoots commonly 2.5–3 mm wide. The leaf is unbordered, and no teeth are visible with a hand lens (microscopically, the margins have bulging cells); the nerve ends in or just below the leaf tip. Sporophytes are occasionally found, arising terminally on the shoot. The leaves almost always have a down-curved tip, giving shoots a distinctive, round-backed appearance not shown by other species of Fissidens.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Fissidens pusillus",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Petty Pocketmoss",
        DESC: "A minute Fissidens with bordered leaves, growing directly on rock, is likely to be one of these two species. The shoots are usually only 1–1.5 mm wide, and fertile shoots are no more than 5 mm tall (although non-fertile shoots in wet places may be a little taller). The leaf tip is acute with straight or convex sides. F. gracilifolius differs from F. pusillus having very elongated leaves at the top of the shoot near the base of the seta (compare with F. limbatus, p. 404), and is typically found in dry habitats, but F. gracilifolius and F. pusillus are difficult to distinguish. ",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Homalothecium lutescens",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Yellow Feathermoss",
        DESC: "H. lutescens is fairly robust, pale or yellowish-green, with irregularly branched shoots that grow in loose, ascending tufts or as scattered stems. A less common form grows prostrate and closely attached to rocks and boulders, especially on limestone. In both cases the branches are stout (1–2 mm wide when dry), fairly long (typically more than 1 cm), and straight or nearly so. The leaves are about 2–3 mm long, triangularly spearhead-shaped, widest at the base, and taper evenly to a finely pointed tip.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 3
      },
      {
        NAME: "Physcomitrium pyriforme",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Common Bladder-moss",
        DESC: "This is a relatively large (shoots up to 5 mm tall), dingy green moss that grows as scattered shoots or loose tufts. The leaves are 3–4 mm long, spreading, with large, lax cells, easily visible with a ×10 hand lens. Capsules are frequent, erect on a long (5–15 mm) seta, and pear-shaped. The lid is short, beaked or abruptly pointed, and the calyptra is usually symmetrical (but can sometimes split asymmetrically).",
        ORDER: "Funariales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Plagiothecium curvifolium",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Curved Silkmoss",
        DESC: "The glossy shoots grow up to 2 cm long, arranged in one plane, and sometimes form extensive patches on acidic substrates. The leaves are about 2.5 mm long, markedly asymmetrical, smaller than in some related species, and are usually turned downwards. Capsules (2 mm long) are very frequently produced, and are smooth when mature and dry (reports to the contrary are errors); they are inclined and curved in P. curvifolium, but more or less erect and straight in P. laetum. These species can be suspected in the field, but microscopic characters (especially the narrow leaf cells) are recommended for confirmation. They are closely related to each other, and some specimens may be difficult to identify.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "F",
        LIGHT: 3,
        MOISTURE: 5
      },
      {
        NAME: "Racomitrium ericoides",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Dense Fringemoss",
        DESC: "The three members of the R. canescens aggregate look quite different from our other Racomitrium species. All three are upright plants with numerous, short branches up the stem. Shoots may grow several centimetres long, and have leaves 2–3 mm long. They have a variable hair point at the end of very roughened leaves, making the leaves appear matt, not shiny, when dry, although R. ericoides can lack hair points entirely. A microscope is needed for certain identification of plants with hair points, but it is possible to assign plants provisionally in the field. ",
        ORDER: "Grimmiales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Schistidium rivulare",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "River Grimmia",
        DESC: "A straggly, dark green moss found on rocks in rivers. The branched shoots are several centimetres long, with leaves 2–2.5 mm long. The leaves lack a hair point, are usually curved, and have recurved margins. Capsules are very short and broad, and are typically very dark red. They are well-hidden by the long leaves that surround them and you may have to search the lower part of the stem in order to find capsules, especially outside the fruiting season of late winter when old, tattered capsules may be all that remain.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Aquatic",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Syntrichia montana",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Intermediate Screwmoss",
        DESC: "G. montana forms small dark green to almost black cushions up to 1 cm tall, with leaves approximately 2.5–3 mm long. The hair point varies in length and can sometimes be as long as the upper leaf blade, making the cushion appear hoary.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 1
      },
      {
        NAME: "Tetrodontium brownianum",
        COUNT: 4,
        COUNTS: 1,
        COMMON: "Brown’s Four-tooth Moss",
        DESC: "The first impression of this tiny moss (2 mm or less tall) is of dark brown sporophytes apparently growing directly out of rock. These have elliptically shaped capsules, borne on a short (4 mm) seta, and 4 large, triangular peristome teeth. The shoots bearing these capsules are tiny, consisting of a few appressed and overlapping leaves that are about 1 mm long, narrowly egg-shaped, with a tapering tip. The upper leaves have poorly developed nerves, but the lower leaves have no nerve.",
        ORDER: "Tetraphidales",
        HABITAT: "QUARRIES",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 2,
        MOISTURE: 7
      },
      {
        NAME: "Bryum creberrimum",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Tight-tufted Threadmoss",
        DESC: "Shoots form dense, dark to light green tufts or cushions, usually between 1 and 4 cm tall. Leaves are 2.5–3.5 mm long, with a well-defined border, do not run down onto the stem at the reddish base, and have a shortly excurrent nerve. Capsules are common in summer, 2.5–4 mm long, drooping or less often nearly horizontal, borne on a seta about 2–3 cm long.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Campylium protensum",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Dull Starry Feathermoss",
        DESC: "C. protensum closely resembles C. stellatum (p. 709). It has prostrate rather than erect shoots, and these tend to be more regularly pinnate. It is generally smaller, the stem leaves mostly being in the range 1–2 mm long. The leaf tip makes up a greater proportion of the leaf (about two-thirds to three-quarters). It very rarely produces capsules.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Didymodon vinealis",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Soft-tufted Beardmoss",
        DESC: "The upper leaves of D. vinealis are 1–3 mm long and bright yellow-green; lower leaves are brown. Shoots usually form dense turfs, 0.5–2 cm tall, but may grow in dense cushions. The leaves twist slightly when dry, and become appressed to the stems. Capsules are rare in spring and summer.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 3
      },
      {
        NAME: "Isopterygiopsis pulchella",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Neat Silk-moss",
        DESC: "The capsules of this moss are usually the first thing that catches the eye, as the 1.25 cm long shoots are so slender they are hard to spot when growing through moss cushions. It is a slender, green, irregularly branched plant. The leaves are 1.25 mm long, held away from the stem and usually point in one direction when moist. They gradually taper into long, fine points, and the nerve is very short and double, or absent. The 2 mm long, narrow, slightly curved capsules are frequently produced.",
        ORDER: "Hypnales",
        HABITAT: "QUARRIES",
        LENGTH: 2,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "O",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Neckera complanata",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Flat Neckera",
        DESC: "The pale yellowish-green shoots of N. complanata are up to 5 cm long, rather rigid and fan-like, and bear smooth leaves less than 2 mm long, with a rounded tip which suddenly contracts into a short point. The very short, double nerve is not visible in the field. Thread-like branches with tiny, distantly spaced leaves can almost always be found if branches of this species are teased apart, and are sometimes very abundant.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Fan",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 4
      },
      {
        NAME: "Orthotrichum speciosum",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Showy Bristlemoss",
        DESC: "O. speciosum is medium-sized to large, usually occurring as dull or deep green, straggling shoots or in small patches. The branches may be erect or creeping. Stem leaves are a little larger than the branch leaves, but are all egg-shaped, with a tapering tip, and mostly 1.5–2 mm long. They have a single nerve reaching almost to the tip, and finely toothed margins. The leaves spread away from the stem and alter little when dry. Branch leaves are narrower and end in a short or long, fine point.",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Plagiomnium ellipticum",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Marsh Thyme-moss",
        DESC: "Non-fertile stems of P. ellipticum on wet ground are usually erect, but sometimes curved, and shoots are up to 9 cm long. Leaves are 5–6 mm long. The leaf cells are longer than wide and arranged in diagonal rows. The leaf base that does not or scarcely runs down onto the stem is an important distinction from related species.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Pleuridium acuminatum",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Taper-leaved Earthmoss",
        DESC: "These little mosses form mid-green or brownish-tinged patches which can be dense, but are often open aggregations of shoots. They are short, to 1 cm, but often less, with the upper leaves much longer than the lower (about 4 mm as opposed to about 1.5 mm), usually erect and occasionally slightly turned to one side. The leaves are spearhead-shaped, tapering relatively gradually from a base that is egg-shaped to a long, fine tip in the upper leaves where it is composed mainly of the excurrent nerve.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Ptilium crista-castrensis",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Ostrich-plume Feathermoss",
        DESC: "The light, bright green, erect or ascending shoots of this moss are large (typically 5 cm or more long) and particularly striking, and are regularly, pinnately branched.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Racomitrium affine",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Lesser Fringemoss",
        DESC: "Field identification of the R. heterostichum aggregate is unwise as its members are very variable. They grow as loose patches on non-calcareous rocks, especially in dry, sunny places. Shoots are typically 2–4 cm long, with leaves 3–4 mm long. All have long (over 2 mm), narrow capsules on a long seta, and most have hair points, with several branches per stem, but hair-point length and the degree of branching vary.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 2
      },
      {
        NAME: "Rhynchostegiella tenella",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Tender Feathermoss",
        DESC: "R. tenella has slender, prostrate shoots growing closely attached to the substrate.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 4
      },
      {
        NAME: "Sphagnum inundatum",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Lesser Cow-horn Bogmoss",
        DESC: "A medium to large species. In open habitats S. inundatum appears golden orange-brown, while in shade it is yellow-green or all green. The capitulum is somewhat stellate, with outer branches straight or curved only at the tip. The branch leaves are spreading, not appressed to the branch, giving the capitulum and upper branches a spiky appearance, hence, despite the common name, not looking like cows’",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Sphagnum quinquefarium",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Five-ranked Bogmoss",
        DESC: "A medium-sized species. Occurs in soft cushions, large hummocks or as carpets over sheltered banks. Capitula are green, a mix of green and pink or, less commonly, largely or all deep red. Capitula are convex to hemispherical. Branch leaves are usually in straight lines, especially those in the capitulum, and when well-developed this is very striking. Almost all fascicles have 3 spreading branches (normally 2 in other species in this Section), and are uniformly and neatly spaced down the stem.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Sphagnum recurvum",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Flat-topped Bog-moss",
        DESC: "Medium-sized, green to mustard-brown, growing in carpets. Male plants may have a contrasting darker tip to the capitula and spreading branches. Capitula are convex and usually stellate, with developing branches in neat pairs, obvious between the capitula rays. Branch leaves are weakly to clearly in straight lines. Spreading and pendent branches are well-differentiated; the pendent branches are almost white, appressed to and hiding the stem, about as long as or shorter than the spreading branches. The stem leaf is more or less triangular. When dry, spreading branch leaves are conspicuously recurved.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Thamnobryum maderense",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Madeiran Feathermoss",
        DESC: "This is about the largest of our tree-like mosses (3–6 mm tall), and typical plants do indeed resemble miniature trees. The upright stems bear small (less than 2 mm long), triangular, scale-like leaves whereas the branches have dark green leaves 1.5–2.5",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Dendroid",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 9
      },
      {
        NAME: "Tortula subulata",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Awl-leaved Screwmoss",
        DESC: "This species seems large to be a Tortula, although its shoots are short (about 5 mm tall). Each is composed of a rosette of large (3–6 mm long), bluntly oblong, bright, mid-green leaves which point well-away from the stem when moist. These are widest above the middle and have a shortly excurrent, yellowish nerve. The leaf margins have a pale border of long, narrow cells that contrasts with the rest of the leaf. Very long (up to 9 mm), narrowly cylindrical capsules are commonly produced in spring and summer, held on a tall (2–3 cm), stout, dark red seta. Several varieties of this species have been described (Smith, p. 346), which are best distinguished microscopically.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 4
      },
      {
        NAME: "Weissia brachycarpa",
        COUNT: 3,
        COUNTS: 1,
        COMMON: "Small-mossouthed Beardless-moss",
        DESC: "This is the second most common British Weissia and, like W. controversa, it is a variable plant that grows either as scattered plants or in dense patches up to 1 cm tall, with leaves 1.75–2.75 mm long, in a range of habitats. The key feature is the small mouth to the cylindrical capsule. This stands up from the body of the capsule and is closed by a membrane. Var. brachycarpa has plane leaf margins; the commoner var. obliqua has them inrolled.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 4
      },
      {
        NAME: "Atrichum tenellum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Slender Smoothcap",
        DESC: "The erect, unbranched, less than 2 cm tall shoots of A. tenellum form dull or brownish-green, low, open patches. The scarcely undulate leaves are 4.5–5.5 mm long, narrowly egg-shaped, distinctly narrowed to the base and have paired marginal teeth only down to mid-leaf. The leaf has 2–4 well-developed ridges of tissue, (3–) 6–9 cells tall, on the ventral surface of the nerve. The uncommon, shortly cylindrical, inclined capsule of this dioicous species is borne on a yellowish seta and matures in autumn or winter. Brownish, more or less spherical gemmae up to 0.4 mm diameter are present on the rhizoids.",
        ORDER: "Polytrichales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Bartramia ithyphylla",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Straight-leaved Apple-moss",
        DESC: "Small-to medium-sized (shoots 0.5–4 cm tall), pale glaucous green tufts or cushions.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Bartramia pomiformis",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Common Apple-moss",
        DESC: "This species of Bartramia forms pale glaucous green cushions and tufts 0.5 to several centimetres tall. The leaves are 4–6 mm long, narrowly spearhead-shaped and sharply pointed, sticking out like spikes from the stem when moist, but curled when dry.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Bryum algovicum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Drooping Threadmoss",
        DESC: "Shoots form dense, dark to light green tufts or cushions, usually between 1 and 4 cm tall. Leaves are 2.5–3.5 mm long, with a well-defined border, do not run down onto the stem at the reddish base, and have a shortly excurrent nerve. Capsules are common in summer, 2.5–4 mm long, drooping or less often nearly horizontal, borne on a seta about 2–3 cm long.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 9,
        MOISTURE: 6
      },
      {
        NAME: "Bryum gemmiferum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Small-bud Bryum",
        DESC: "This small moss, typically about 1 cm tall, grows as tufts and scattered shoots. The concave leaves are short (about 1.1–1.2 mm long) in relation to their width when compared with most other Bryum species, and shelter 20–30 small (0.1–0.16 mm long), pale yellowish-green (or sometimes – but not typically – orange or red) bulbils in the axils. These clusters of bulbils are sufficiently conspicuous to be visible from a few feet away. Pendulous, egg-shaped capsules 1.5 mm long develop occasionally.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Bryum klinggraeffii",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Raspberry Bryum",
        DESC: "B. rubens is quite small and delicate for a Bryum. Shoots are usually no more than 1 cm tall; occasionally up to 1.5 cm. Stems are often reddish, and the leaves (about 2 mm long) may be slightly tinged red. Rhizoids are reddish-brown. Capsules are 2 mm long and frequent. The bright red tubers (white when young) are the best clue to identifying this moss in the field, and usually occur at the base of the lower leaves. Tubers also grow on the longer rhizoids (especially in plants not found in arable fields), and can be seen by crumbling the soil in which the plants are growing.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 6
      },
      {
        NAME: "Bryum rubens",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Crimson-tuber Threadmoss",
        DESC: "B. rubens is quite small and delicate for a Bryum. Shoots are usually no more than 1 cm tall; occasionally up to 1.5 cm. Stems are often reddish, and the leaves (about 2 mm long) may be slightly tinged red. Rhizoids are reddish-brown. Capsules are 2 mm long and frequent. The bright red tubers (white when young) are the best clue to identifying this moss in the field, and usually occur at the base of the lower leaves. Tubers also grow on the longer rhizoids (especially in plants not found in arable fields), and can be seen by crumbling the soil in which the plants are growing.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 5
      },
      {
        NAME: "Bryum subapiculatum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Lesser Potato Bryum",
        DESC: "B. rubens is quite small and delicate for a Bryum. Shoots are usually no more than 1 cm tall; occasionally up to 1.5 cm. Stems are often reddish, and the leaves (about 2 mm long) may be slightly tinged red. Rhizoids are reddish-brown. Capsules are 2 mm long and frequent. The bright red tubers (white when young) are the best clue to identifying this moss in the field, and usually occur at the base of the lower leaves. Tubers also grow on the longer rhizoids (especially in plants not found in arable fields), and can be seen by crumbling the soil in which the plants are growing.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 4
      },
      {
        NAME: "Bryum tenuisetum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Yellow-tuber Threadmoss",
        DESC: "B. rubens is quite small and delicate for a Bryum. Shoots are usually no more than 1 cm tall; occasionally up to 1.5 cm. Stems are often reddish, and the leaves (about 2 mm long) may be slightly tinged red. Rhizoids are reddish-brown. Capsules are 2 mm long and frequent. The bright red tubers (white when young) are the best clue to identifying this moss in the field, and usually occur at the base of the lower leaves. Tubers also grow on the longer rhizoids (especially in plants not found in arable fields), and can be seen by crumbling the soil in which the plants are growing.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 6
      },
      {
        NAME: "Dicranella cerviculata",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Red-neck Forklet-moss",
        DESC: "Fruiting plants that look like small (0.5–2 cm tall) D. heteromalla should be checked for this species, which shares the approximately 2.5–3 mm long, narrow, curved leaves and yellow setae of that very common acid-loving moss. The difference between them lies in the capsule, which has a prominent swelling (like a man’s well-developed Adam’s apple) where it joins the seta. The relatively restricted habitat preferences of D. cerviculata mean that carefully checking many populations of D. heteromalla is unnecessary.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Didymodon ferrugineus",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Rusty Beardmoss",
        DESC: "Forming patches or loose tufts, the red-brown shoots, tipped with green, may grow up to 2 cm tall, with leaves that are about 1–1.5 mm long and are strongly bent back away from the stem. The 3-ranked arrangement of the leaves is normally a very distinctive and easily observed character. Capsules are unknown in Britain.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Drepanocladus polygamus",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Fertile Feathermoss",
        DESC: "Until recently, D. polygamus was thought to be a species of Campylium with a nerve. This is certainly its general appearance: it is similar in size to C. stellatum, although it lacks that species’ brown or orange colours and its leaves are typically less spreading. Its shoots do have a rather starry tip, but often the leaves further down the stem are slightly curved. Leaves are 1.6–3 mm long. Unlike the dioicous C. stellatum, D. polygamus has male and female organs on the same shoot, and frequently produces 2 mm long capsules: a useful pointer in the field.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 9,
        MOISTURE: 8
      },
      {
        NAME: "Gyroweisia tenuis",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Slender Stubble-moss",
        DESC: "Forms light green patches or scattered stems only 2 or 3 mm tall. The leaves are 0.5–1 mm long, strap-shaped and the blunt, rounded tip is easily visible with a hand lens. Capsules sometimes occur.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 1,
        MOISTURE: 6
      },
      {
        NAME: "Hedwigia stellata",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Starry Hoarmoss",
        DESC: "The 3–10 cm long, irregularly branched shoots of H. stellata form loose tufts and patches. They are glaucous green or brownish when moist, becoming pale grey as they dry. The concave, oval leaves are about 2.5 mm long, lack a nerve, and usually have a wide, colourless tip that forms a characteristic white triangle. When moist, the leaf tip is held at an angle of 45–90° from the stem; when dry, the tip becomes reflexed or recurved, giving shoot tip a starry appearance. Some forms of H. stellata have slightly curved leaves, but otherwise are not distinct from normal forms.",
        ORDER: "Hedwigiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 1
      },
      {
        NAME: "Hygroamblystegium fluviatile",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Brook-side Feathermoss",
        DESC: "These two species are very variable, forming smallish to robust, dingy green patches and tufts. In some forms, the shoots have short, more or less pinnate branches; other forms have fewer elongated branches that are parallel to the stem.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 11
      },
      {
        NAME: "Leptobryum pyriforme",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Golden Threadmoss",
        DESC: "L. pyriforme has long (to 6 mm), narrow, widely spreading, shiny, yellow-green leaves with a wide nerve reaching the tip. Dark brown rhizoids, if visible near the base of the stem, are another useful diagnostic feature, as are the dark, purplish-brown or black, club-shaped tubers which sometimes occur in abundance. The shiny brown, narrowly pear-shaped, horizontal or pendent 1.5–2.5 mm long capsules are held on a seta 1–3 cm long, and are unmistakable when present. Perfect specimens seen in perfect conditions with a ×20 hand lens may reveal the red-purple axillary hairs, but this definitive character is too difficult to see in the field to be a practicable field character.",
        ORDER: "Splachnales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Leucodon sciuroides",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Larger Squirrel-tail Moss",
        DESC: "Shoots of L. sciuroides are typically 4–5 cm long. When dry, vigorous colonies of this medium-sized or large, brownish-green or brown moss have tightly appressed leaves, with stems and branches curved like a longbow. Leaves are about 3 mm long. The sparsely branched stems are attached to the substrate only at the base. Moist plants are less immediately distinctive, but can be identified by the longitudinally pleated leaves, which taper to an acute, but not finely pointed tip, lack a nerve, and have rounded cells. Tiny, easily detached branchlets are often found in a mass at the stem tip, but capsules are rare.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Neckera crispa",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Crisped Neckera",
        DESC: "Neckera species have fan-like branches, which tend to project outwards from the substrate, and leaves with a very short nerve. N. crispa is the most robust, a strikingly handsome moss which often grows in large, luxuriant patches (stems more than 4 cm and leaves more than 2 mm long). It has glossy leaves which are undulate both when moist and dry, and turn brown with age.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 5,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Oxyrrhynchium pumilum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Dwarf Feathermoss",
        DESC: "O. tenellum are composed of several narrow, upright shoots with appressed leaves, topped by narrow capsules almost completely hidden by a long, sparsely hairy, light green calyptra. The plants are consistently less than 1 cm tall and are often less than 5 mm in height, with leaves 2.5–3 mm long and capsules 2 mm long. Unripe capsules are light green; when ripe or old they become golden brown, and have 8 reflexed, orange outer peristome teeth.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 5
      },
      {
        NAME: "Oxyrrhynchium speciosum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Showy Feathermoss",
        DESC: "O. speciosum is medium-sized to large, usually occurring as dull or deep green, straggling shoots or in small patches. The branches may be erect or creeping. Stem leaves are a little larger than the branch leaves, but are all egg-shaped, with a tapering tip, and mostly 1.5–2 mm long. They have a single nerve reaching almost to the tip, and finely toothed margins. The leaves spread away from the stem and alter little when dry. Branch leaves are narrower and end in a short or long, fine point.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 8
      },
      {
        NAME: "Philonotis arnellii",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Arnell’s Apple-moss",
        DESC: "Very small and slender, the pale or bright green shoots are only 0.5–1 cm tall, with extremely small leaves (0.6–0.9 mm long) that typically have a relatively very long tip and plane margins. Fragile shootlets may arise from the axils of leaves. Capsules are very rarely produced in summer.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Pohlia cruda",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Opal Threadmoss",
        DESC: "P. cruda forms rather loose tufts 2–4 cm tall. Its leaves are 2.5 mm long, pale or glaucous green, and have a characteristic opalescent sheen. The stems are red.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 6
      },
      {
        NAME: "Pohlia elongata",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Sharp-leaved Threadmoss",
        DESC: "Shoots are 0.5–5 cm tall, dull or pale green. Lower leaves are 2 mm long and broadly spearhead-shaped. Upper leaves are narrow and grow up to 4 mm long. They are held more or less erect, and alter little when dry. The prominent nerve ends in or just below the tip. The capsules are the most distinctive feature of P. elongata, and form in summer and autumn. They are typically 4–6 mm long, narrowly pear-shaped or spindle-shaped and taper at both ends, with the neck forming up to half of this length, held inclined or horizontal or drooping, on a seta 1.5–3 cm tall.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Pylaisia polyantha",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Many-flowered Leskea",
        DESC: "P. polyantha forms slender, creeping, yellowish-green to green, irregularly to pinnately branched, often untidy patches. Shoots are 1–2 cm tall. The leaves are 1–1.5 mm long, erect, often tending to point in one direction when moist, but are appressed when dry. The nerve is very short and double, or absent. Dwarf, fertile branches are abundantly produced. The most distinctive feature of the plant is its copiously produced, 1.5 mm long capsules, two or more generations of which are typically present. In late spring the shoots support clumps of old capsules from one season and very young capsules from a later season.",
        ORDER: "Hypnales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 4
      },
      {
        NAME: "Rhizomnium pseudopunctatum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Felted Thyme-moss",
        DESC: "The erect shoots are 4–12 cm tall in R. pseudopunctatum, and 2–7 cm tall in R.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 9
      },
      {
        NAME: "Schistidium platyphyllum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Broadleaf Grimmia",
        DESC: "This dark green, branched moss resembles S. rivulare. Shoots are 0.5–4 cm long, with leaves 1.75–2 mm long. Its leaves are broader and shorter than those of most British Schistidium species, and they have rounded backs, unlike the keeled leaves of other members of the genus. They usually lack a hair point, although the leaves around the capsule often have a very short hair point. The capsules are short, broad and dark red, and easily visible because they are hardly hidden by the leaves that sheath them, which are only as long as the capsules themselves.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Aquatic",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Schistidium robustum",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Robust Grimmia",
        DESC: "This moss of upland, calcareous rocks looks similar to S. crassipilum and needs to be consciously searched for in suitable places. Usually, the first thing that draws attention is the way that the long capsules, partly hidden by leaves, stand out above its loose (or sometimes dense), hoary cushions. A hand lens will show that the long hair point has plenty of sharp teeth, but a microscope is needed for certain identification.",
        ORDER: "Grimmiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "Yes",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 2
      },
      {
        NAME: "Schistostega pennata",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Goblin Gold",
        DESC: "The scattered, frond-like shoots of this unique moss emerge from a persistent protonema that has refractive, lens-like cells causing the plant to shine like cats’ eyes.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 1,
        MOISTURE: 7
      },
      {
        NAME: "Trichodon cylindricus",
        COUNT: 2,
        COUNTS: 1,
        COMMON: "Cylindric Ditrichum",
        DESC: "This is the ‘Miss Whiplash’ of British mosses. Shoots are up to 5 mm tall. Mature plants have an expanded leaf base which sheaths the stem and contracts abruptly to a leaf blade which is long and narrow, rather wavy and minutely toothed. Leaves are 2–2.5 mm long. Capsules are very rare.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 5
      },
      {
        NAME: "Bryum radiculosum",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Wall Threadmoss",
        DESC: "B. radiculosum forms dark, shiny green, compact tufts or cushions, with shoots closely packed together. The prominent nerve, excurrent at the leaf tip, makes the leaves (1.5–2.25 mm long) look characteristically straight. B. radiculosum has very small, spherical, red-brown, rhizoidal tubers, but these are usually only visible with a microscope. Capsules are about 3–5 mm long, common, forming in early summer.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 2,
        ARRANGE: "Cushion",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 3
      },
      {
        NAME: "Calliergonella lindbergii",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Lindberg’s Plaitmoss",
        DESC: "C. lindbergii forms rather flattened, green, glossy, sparingly branched, medium-sized (commonly 1.5–2 mm wide) shoots. These often stick up, forming small tufts or more extensive turfs. The leaves are nearly 2 mm long, curve towards the underside of the shoot, and taper gradually to an acute or longly acute point. The nerve is absent, or short and double. Stems are greenish or tinged reddish-brown. Microscopically, the leaf margins are entire below, but usually finely toothed near the tip, and the basal angles have a patch of enlarged cells.",
        ORDER: "Hypnales",
        HABITAT: "SOIL",
        LENGTH: 4,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 7
      },
      {
        NAME: "Didymodon spadiceus",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Brown Beardmoss",
        DESC: "Greenish-brown shoots are typically 1.5–3 cm tall, with straight leaves (but recurved near the base) about 2–4 mm long, held nearly at right angles to the stem when moist. Cylindrical capsules are fairly frequent, and have short, straight peristome teeth.",
        ORDER: "Pottiales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 7
      },
      {
        NAME: "Ephemerum minutissimum",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Minute Earthmoss",
        DESC: "These two minute mosses have tiny (1–2 mm tall) shoots emerging from a persistent, dark green or brownish-tinged protonema. The leaves are about 1 mm long, strongly toothed, and not or only very faintly nerved. Capsules are almost always present, more or less spherical and with a short tip, and surrounded by the leaves. E. serratum has coarsely roughened spores, whereas E. minutissimum has finely roughened spores, so the two species can only be distinguished by microscopical examination of mature material.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Fissidens fontanus",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Fountain Pocket-moss",
        DESC: "O. fontanum is flaccid, with much-branched shoots up to 3 cm long. The shoots appear flattened, with long, narrow leaves in 2 rows on the stem. O. fontanum shares the very distinctive leaf structure of Fissidens, but the sheathing part of the leaf blade is less than a third the length of the whole leaf. Each leaf is up to 5 mm long and about 10 times as long as wide, with unbordered margins (i.e. margins without cells much longer than wide). The narrow but distinct nerve ceases just below the leaf tip.",
        ORDER: "Dicranales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Aquatic",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 12
      },
      {
        NAME: "Heterocladium wulfsbergii",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Wulfsberg’s Tamarisk-moss",
        DESC: "Well-grown H. heteropterum forms shoots up to about 3 cm long. It is dingy, dark green, with roughly pinnate branching, down-curved stem leaves and short nerves (to less than halfway up the leaf). Stem leaves are about twice the size of the branch leaves (about 1 and 0.5 mm long, respectively); both taper to short, acute points.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 3,
        MOISTURE: 6
      },
      {
        NAME: "Isothecium alopecuroides",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Larger Mouse-tail Moss",
        DESC: "I. alopecuroides is distinctively pale or yellowish-green. It is usually fairly robust, with shoots commonly 2–6 cm long, but smaller forms occur. The plants are bushy, with the branches curving downwards. The branch leaves are typically 2 mm long, egg-shaped to elliptical, concave, appressed and overlapping, giving the branches a neatly cylindrical appearance. They do not alter much when dry. The leaf tip is broadly pointed to acute, not drawn out to a fine point, and only finely toothed. The single nerve extends above mid-leaf. Stem leaves are similar to the branch leaves, but a little larger, with a slightly longer tip. Capsules appear occasionally, and are elliptical to cylindrical, and erect. The lid is beaked.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Dendroid",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Isothecium holtii",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Holt’s Mouse-tail Moss",
        DESC: "Like I. myosuroides, I. holtii has a bushy or sometimes tree-like growth form, with shoots growing away from the substrate. Its crowded branches are usually more numerous in the upper part of the shoots, and arch downwards. The plants become distinctively bronzed or orange-brown. Shoots are commonly 2–5 cm long. Stem leaves are 2 mm long. Branch leaves are about 1.5 mm long, overlapping, neatly appressed to slightly spreading when both moist and dry, and are egg-shaped to elliptical, with a shorter point than I. myosuroides. They have a single nerve, and are very finely toothed. Capsules are rare.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Dendroid",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 8
      },
      {
        NAME: "Leptodontium flexifolium",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Bent-leaved Beardmoss",
        DESC: "This species appears at first glance to be a Barbula growing on an acidic substrate. It is a small (shoots 2–15 mm tall), yellow-green moss, growing in loose patches or as scattered individuals. Leaves vary in size from 1 mm long to over 2 mm. The broad, often rounded leaf tip has coarse marginal teeth, easily seen with a hand lens. The leaf is often bent backwards, and is tongue-shaped with a distinct nerve that ends below the leaf tip. The moss shrivels up when dry, making these features difficult to see. Upon wetting, however, the characteristic shape and teeth become obvious.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "R",
        LIGHT: 7,
        MOISTURE: 4
      },
      {
        NAME: "Leptodontium gemmascens",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Thatch-moss",
        DESC: "This species forms small, yellow-green cushions or scattered shoots. Although only a few millimetres tall, with leaves a little over 1 mm long, it is easy to recognize on account of the characteristic cluster of tiny, green gemmae perched on an excurrent nerve at the leaf tip, and easily seen with a hand lens. The spearhead-shaped leaves taper to a coarsely toothed tip. Capsules are unknown, so the gemmae provide the main means of dispersal.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "F",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Leskea polycarpa",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Many-fruited Leskea",
        DESC: "This slender moss forms dull, dark yellow-green, irregularly branched patches and tufts, in which short, curved or nearly upright branches up to about 4 mm long (although mats can be 2–3 cm across) arise from prostrate primary stems. Plants are often covered with silt. The crowded leaves are about twice as long as wide (about 1 mm or less long, 0.5 mm wide), held pointing away from the stem, and change little when dry. The nerve is well-developed in the lower half of the leaf, but disappears in mid-leaf. Cylindrical capsules are usually abundant in summer. They are about 3 mm long – 4 times longer than wide – and held erect or slightly inclined to the vertical.",
        ORDER: "Hypnales",
        HABITAT: "ON WOOD",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 5
      },
      {
        NAME: "Loeskeobryum brevirostre",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Short-beaked Woodmoss",
        DESC: "The shoots of this medium-sized (7–12 cm long) moss have dull, yellow-green, irregularly branched branches, and red-brown stems. Stem leaves are typically 2–3 mm long, broadly triangular, and taper to a long, narrow point, which is often curved to one side when moist, and irregularly but conspicuously undulate when dry.",
        ORDER: "Hypnales",
        HABITAT: "HARD ROCK",
        LENGTH: 4,
        ARRANGE: "Weft",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 4,
        MOISTURE: 6
      },
      {
        NAME: "Phascum cuspidatum",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Cuspidate Earthmoss",
        DESC: "Shoots form fresh, green patches 2–6 mm tall. The broad leaves are 1–3 mm long, and surround and partly hide the spherical capsules, which are borne on an extremely short (up to 0.5 mm long) seta and have a small protuberance at the top.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 5
      },
      {
        NAME: "Philonotis caespitosa",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Tufted Apple-moss",
        DESC: "P. caespitosa forms slender, light green shoots up to 5 cm tall. Its leaves are 0.5–",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 9
      },
      {
        NAME: "Physcomitrium sphaericum",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Dwarf Bladder-moss",
        DESC: "P. sphaericum grows in scattered shoots or loose tufts up to 4 mm tall. The more or less untoothed leaves are 1.5–2 mm long, spread away from the stem, and have large, lax cells, easily visible with a ×10 hand lens. The leaves of P. sphaericum appear blunt, and almost hooded owing to the slightly inrolled margins. Capsules are frequent, almost spherical, and erect on a short (less than 5 mm) seta, with a convex or hemispherical, shortly pointed lid.",
        ORDER: "Funariales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 8
      },
      {
        NAME: "Plagiomnium cuspidatum",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Woodsy Thyme-moss",
        DESC: "Shoots are 1.5–4 cm tall. The leaves of P. cuspidatum are 2.5–3.5 mm long, and taper more gradually at the tip than those of other Plagiomnium species. The margins are sharply toothed, but the teeth are more or less confined to the upper half of the leaf, and the leaf base runs down onto the stem. The cells are small, no longer than wide, and are not arranged in diagonal rows.",
        ORDER: "Bryales",
        HABITAT: "HARD ROCK",
        LENGTH: 3,
        ARRANGE: "Mat",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 6,
        MOISTURE: 6
      },
      {
        NAME: "Pleuridium subulatum",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Awl-leaved Earthmoss",
        DESC: "This is the ‘Miss Whiplash’ of British mosses. Shoots are up to 5 mm tall. Mature plants have an expanded leaf base which sheaths the stem and contracts abruptly to a leaf blade which is long and narrow, rather wavy and minutely toothed. Leaves are 2–2.5 mm long. Capsules are very rare.",
        ORDER: "Dicranales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 6
      },
      {
        NAME: "Pohlia flexuosa",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Orange-bud Threadmoss",
        DESC: "P. annotina is a small (about 0.75–1 cm tall), delicate-looking, pale green moss with many (usually 3 to about 20) light green bulbils in each of the leaf axils on the upper part of the shoots. These bulbils are less than 0.5 mm long, vary greatly in shape, and are visible to the naked eye when they form clusters in the leaf axils.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 3,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 7
      },
      {
        NAME: "Pohlia lutescens",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Yellow Threadmoss",
        DESC: "P. lutescens is a subtle species, but once known it is found widely, being recognized by its small size and pale colour. Its shoots are small (3–8 mm tall), with glossy, pale yellow-green leaves 2–3 mm long. P. lutescens may grow as scattered shoots (or occasionally as patches) among other bryophytes, such as Dicranella heteromalla (p. 371), Calypogeia arguta (p. 90) or Diplophyllum albicans (p. 166). Capsules are not known in Britain.",
        ORDER: "Bryales",
        HABITAT: "SOIL",
        LENGTH: 2,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 5
      },
      {
        NAME: "Sphagnum angustifolium",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Fine Bogmoss",
        DESC: "Small-to medium-sized, green or mustard-brown, with a convex capitulum (sometimes markedly so, like pom-poms). Branch leaves are in straight lines in the basal half of spreading branches. Except when in shade, spreading branches are pinkish near the base, sometimes extensively so. Pendent branches are longer than spreading branches, with some up to twice as long, very thin and almost white. Stem leaves are small, roughly equilateral-triangular, with a blunt tip, which may be slightly eroded or look notched (if leaf margins are inrolled it can look deceptively pointed; check several to be sure). When dry, the spreading branch leaves are conspicuously recurved.",
        ORDER: "Sphagnales",
        HABITAT: "SOIL",
        LENGTH: 5,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "",
        GEMMAE: "",
        LIGHT: 7,
        MOISTURE: 8
      },
      {
        NAME: "Ulota drummondii",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Drummond’s Pincushion",
        DESC: "U. drummondii is most easily found on dry days, when the fact that its leaves are only slightly curled when dry becomes apparent. On wet days, it looks much like a reddish U. bruchii. It forms reddish-green or yellowish-green tufts or patches 0.5–",
        ORDER: "Orthotrichales",
        HABITAT: "ON WOOD",
        LENGTH: 2,
        ARRANGE: "Tuft",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 5,
        MOISTURE: 5
      },
      {
        NAME: "Weissia rostellata",
        COUNT: 1,
        COUNTS: 1,
        COMMON: "Beaked Beardless-moss",
        DESC: "The unusual, shortly cylindrical capsules on a short seta, half hidden among long leaves that that arise from beside the base of the sporophyte give this Weissia a distinctive appearance. The capsules do not shed their lid, and partly broken-down examples can often be found in situ with a hand lens. W. rostellata forms low (5 mm tall), loosely tufted patches of yellow-green plants. Leaves are 1.5–2.5 mm long.",
        ORDER: "Pottiales",
        HABITAT: "SOIL",
        LENGTH: 1,
        ARRANGE: "Turf",
        LEAF: "",
        HAIR: "",
        NERVE: "Yes",
        GEMMAE: "",
        LIGHT: 8,
        MOISTURE: 7
      }
    ];